(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2142,3606],{

/***/ 63606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CheckOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CheckOutlined.js
// This icon file is generated automatically.
var CheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
/* harmony default export */ var asn_CheckOutlined = (CheckOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(42135);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckOutlined_CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CheckOutlined
  }));
};
if (false) {}
/* harmony default export */ var icons_CheckOutlined = (/*#__PURE__*/react.forwardRef(CheckOutlined_CheckOutlined));

/***/ }),

/***/ 81244:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[id]",
      function () {
        return __webpack_require__(56590);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ getListReviewProject; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26509);




const getListReviewProject = async (project, params, headers)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("v1/comments/project/".concat(project));
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].POST */ .Z.POST, path, {
        ...params
    }, headers);
    return response;
};


/***/ }),

/***/ 50859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getListSearchHistory; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26509);




const getListSearchHistory = async (header)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("v1/projects/search-history");
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GET */ .Z.GET, path, null, header);
    return response;
};


/***/ }),

/***/ 36361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ saveSearchHistory; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26509);




const saveSearchHistory = async (params, headers)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("v1/projects/savehistory");
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].POST */ .Z.POST, path, params, headers);
    return response;
};


/***/ }),

/***/ 44217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33172);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _NotificationPopupContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65037);
/* harmony import */ var _vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77027);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);








const NotiMobile = ()=>{
    const { token , user  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .a)();
    const [countNoti, setCountNoti] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const seenAllNoti = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(async ()=>{
        if (token) try {
            await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].request */ .Z.request({
                method: "POST",
                url: "/v1/notifications/view",
                baseURL: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG,
                headers: {
                    Authorization: "Bearer ".concat(token)
                }
            });
            setCountNoti(0);
        } catch (error) {}
    }, [
        token
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (token) axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].request */ .Z.request({
            baseURL: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG,
            url: "/v1/notifications/count",
            headers: {
                Authorization: "Bearer ".concat(token)
            }
        }).then((res)=>{
            setCountNoti(res.data.count);
        });
    }, [
        token
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (countNoti && open) seenAllNoti();
    }, [
        open,
        seenAllNoti,
        countNoti
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (open) (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_5__/* .lockScroll */ .dg)();
        else (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_5__/* .unlockScroll */ .pX)();
        return ()=>{
            (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_5__/* .unlockScroll */ .pX)();
        };
    }, [
        open
    ]);
    return user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("fixed w-screen h-screen  top-0 bg-white z-20 duration-300", open ? "left-0 " : "left-full"),
                children: open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NotificationPopupContent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    titleClassName: "!text-fs-20",
                    allowBack: true,
                    onClose: ()=>setOpen(false),
                    onBack: ()=>setOpen(false)
                }) : null
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "rounded-full bg-blue-50 w-9 h-9 flex items-center justify-center relative cursor-pointer",
                onClick: ()=>setOpen(true),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "mrv mrv-notifications text-fs-20 text-blue-500"
                    }),
                    countNoti ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-0 -right-2 text-white bg-red-500 rounded-full text-fs-12 px-1",
                        children: countNoti
                    }) : null
                ]
            })
        ]
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (NotiMobile);


/***/ }),

/***/ 48831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Seo_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47727);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7181);





const Meta = (param)=>{
    let { ogImage , noindex , nofollow , additionalMetaTags , title , description , canonical  } = param;
    const ogImages = {
        url: "".concat(_constants_environment__WEBPACK_IMPORTED_MODULE_4__/* .STATIC_DOMAIN */ .xm, "/images/thumb-image.png"),
        width: 720,
        height: 540,
        alt: _components_Seo_base__WEBPACK_IMPORTED_MODULE_3__/* .BaseMetaSeo.metaTitle */ .o.metaTitle
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "UTF-8"
                    }, "charset"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "shortcut icon",
                        href: "".concat(_constants_environment__WEBPACK_IMPORTED_MODULE_4__/* .STATIC_DOMAIN */ .xm, "/images/favicon.ico")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                noindex: noindex,
                nofollow: nofollow,
                additionalMetaTags: additionalMetaTags,
                title: title,
                description: description,
                canonical: canonical,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    site_name: _components_Seo_base__WEBPACK_IMPORTED_MODULE_3__/* .BaseMetaSeo.siteName */ .o.siteName,
                    images: [
                        ogImage ? ogImage : ogImages
                    ]
                }
            })
        ]
    });
};



/***/ }),

/***/ 47727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ BaseMetaSeo; }
/* harmony export */ });
/* harmony import */ var _constants_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24435);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _utils_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77325);



const metaTitle = "Meey Review - Diễn đ\xe0n đ\xe1nh gi\xe1 đa chiều bất động sản dự \xe1n";
const metaDescription = "Minh bạch h\xf3a th\xf4ng tin về c\xe1c dự \xe1n bất động sản th\xf4ng qua đ\xe1nh gi\xe1 đa chiều c\xf3 cơ sở của kh\xe1ch h\xe0ng theo thời gian thực nhằm bảo vệ quyền v\xe0 lợi \xedch của c\xe1c b\xean li\xean quan trong chuỗi ph\xe1t triển bất động sản.";
const metaKeyword = "mua b\xe1n cho thu\xea nh\xe0 đất - bất động sản";
const urlImage = (0,_utils_image__WEBPACK_IMPORTED_MODULE_2__/* .resizeOnFlyUrl */ .Li)({
    uri: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_IMAGE_URI */ .mG,
    width: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].width */ .$H["default"].width,
    height: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].height */ .$H["default"].height,
    resizingType: "fill",
    gravity: "no"
});
const baseImage = {
    url: "".concat(_constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .STATIC_DOMAIN */ .xm, "/images/thumb_image.png"),
    description: null,
    name: "capture-meeyhome.jpg",
    mimeType: "image/jpeg",
    width: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].width */ .$H["default"].width,
    height: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].height */ .$H["default"].height,
    alt: "Trang chủ"
};
const BaseMetaSeo = {
    baseUrlImage: urlImage,
    metaTitle: metaTitle,
    metaDescription: metaDescription,
    metaKeyword: metaKeyword,
    siteName: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_DOMAIN */ .wz,
    locale: "vi_VN",
    canonical: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_BASE_URL */ .E5,
    baseImage: baseImage,
    openGraph: {
        title: metaTitle,
        description: metaDescription,
        images: [
            baseImage
        ],
        site_name: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_DOMAIN */ .wz,
        locale: "vi_VN",
        url: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_BASE_URL */ .E5,
        type: "website",
        article: {
            authors: [
                "https://www.facebook.com/meeyland.global/"
            ]
        }
    },
    facebook: {
        appId: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .FB_APP_ID */ .f6
    },
    twitter: {
        site: "@meey_review"
    },
    additionalMetaTags: [
        {
            name: "keywords",
            content: metaKeyword !== null && metaKeyword !== void 0 ? metaKeyword : ""
        },
        {
            property: "fb:pages",
            content: "148873268971895"
        },
        {
            property: "article:author",
            content: "https://www.facebook.com/meeyland.global/"
        },
        {
            property: "twitter:creator",
            content: "@meey_review"
        },
        {
            property: "twitter:title",
            content: metaTitle || ""
        },
        {
            property: "twitter:description",
            content: metaDescription || ""
        },
        {
            property: "twitter:image",
            content: urlImage
        },
        {
            property: "twitter:image:width",
            content: "".concat(_constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].width */ .$H["default"].width)
        },
        {
            property: "twitter:image:height",
            content: "".concat(_constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].height */ .$H["default"].height)
        },
        {
            property: "og:locale:alternate",
            content: "vi_VN"
        }
    ],
    siteLinkSearchBox: {
        type: "Website",
        name: "Meey Review",
        url: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_BASE_URL */ .E5
    }
};


/***/ }),

/***/ 89155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z2": function() { return /* binding */ getCanonicalUrl; },
/* harmony export */   "Z8": function() { return /* binding */ getOriginUrl; }
/* harmony export */ });
/* unused harmony exports generateCanonicalUrl, getPathWithSolidus, convertObjectToQueryString, getUrlPage, getPath */
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82898);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);




const getCanonicalUrl = (router)=>{
    return (_constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_BASE_URL */ .E5 + (router.asPath === "/" ? "" : router.asPath)).split("?")[0] || "";
};
const generateCanonicalUrl = (canonicalUrl)=>"".concat(APP_BASE_URL, "/").concat(canonicalUrl);
const getOriginUrl = (url)=>{
    return url.split("?")[0] || "";
};
const getPathWithSolidus = (path)=>{
    return path.startsWith("/") ? path : "/".concat(path);
};
const convertObjectToQueryString = (input)=>{
    if (!input) return "";
    const params = removePropertiesEmpty(input);
    let objectQueryString = {};
    Object.keys(params).map((key)=>{
        if (typeof params[key] !== "object" || Array.isArray(params[key])) {
            objectQueryString[key] = params[key];
        } else {
            var _params_key;
            objectQueryString[key] = qs.stringify((_params_key = params[key]) !== null && _params_key !== void 0 ? _params_key : {}, {
                arrayFormat: "bracket-separator",
                skipEmptyString: true,
                skipNull: true
            });
        }
    });
    return qs.stringify(objectQueryString, {
        skipNull: false,
        arrayFormat: "separator"
    });
};
const getUrlPage = (basePath, input)=>{
    const queryString = removePropertiesEmpty(input);
    return urlJoin(basePath, queryString && Object.keys(queryString).length ? "?".concat(convertObjectToQueryString(input)) : "");
};
const getPath = function(path) {
    let allowBaseUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const currentPath = getPathWithSolidus(path);
    return allowBaseUrl ? "".concat(APP_BASE_URL).concat(currentPath) : currentPath;
};


/***/ }),

/***/ 15085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40364);
/* harmony import */ var _components_MeeyImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3524);
/* harmony import */ var _components_PopupAvatarUser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84536);
/* harmony import */ var _components_PopupNotification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8440);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7181);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33172);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Home_HeaderHome_SearchProject__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82620);









const HeaderDetail = ()=>{
    const { user , login  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .a)();
    // const [mounted, setMounted] = useState(false);
    // useEffect(() => {
    //   setMounted(true);
    // }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white flex items-center justify-between h-14 w-full pl-10 pr-[60px] sticky top-0 z-30 shadow-light-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                href: "/",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MeeyImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: _constants_environment__WEBPACK_IMPORTED_MODULE_5__/* .STATIC_DOMAIN */ .xm + "/logo_blue.svg",
                    alt: "home",
                    resizeOnFly: false,
                    resizeOptions: {
                        width: 131,
                        height: 42
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center bg-grey-100 w-[26.5rem] h-10 rounded-md py-2 pl-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "mrv mrv-search text-fs-20 text-grey-500"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Home_HeaderHome_SearchProject__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        showSuffixIcon: false,
                        className: "w-[calc(100%-32px)]",
                        allowClear: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-5 w-[13rem] justify-end",
                children: [
                    !user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        color: "white",
                        onClick: login,
                        className: "meey-button meey-button-grey meey-button-outline py-2.5 px-4 h-9 flex items-center gap-1",
                        btnType: "outline",
                        prefixIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "mrv mrv-account_circle text-fs-18",
                            children: " "
                        }),
                        children: "Đăng nhập"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopupNotification__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopupAvatarUser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderDetail);


/***/ }),

/***/ 20179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_MeeyImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3524);
/* harmony import */ var _components_PopupAvatarUser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84536);
/* harmony import */ var _components_PopupNotification_NotiMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44217);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7181);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33172);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);







const HeaderDetail = ()=>{
    const { user , login  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .a)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white flex items-center justify-between h-14 w-full sticky top-0 z-30 shadow-light-2 px-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                href: "/",
                title: "home",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MeeyImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    src: _constants_environment__WEBPACK_IMPORTED_MODULE_4__/* .STATIC_DOMAIN */ .xm + "/logo_blue.svg",
                    alt: "home",
                    resizeOnFly: false,
                    resizeOptions: {
                        width: 131,
                        height: 42
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex gap-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center gap-5",
                    children: [
                        !user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center gap-1 bg-grey-100 h-10 rounded-full py-2 px-3",
                            onClick: login,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "mrv mrv-account_circle text-fs-20 text-grey-500"
                            })
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopupNotification_NotiMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopupAvatarUser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderDetail);


/***/ }),

/***/ 5762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProjectDetail_ListReview; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/endpoint/reviews/get-list-review-project.ts
var get_list_review_project = __webpack_require__(12565);
// EXTERNAL MODULE: ./src/context/project.context.tsx
var project_context = __webpack_require__(12482);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 2 modules
var useAuth = __webpack_require__(33172);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./src/utils/index.ts + 2 modules
var utils = __webpack_require__(67650);
// EXTERNAL MODULE: ./src/components/AvatarWithName.tsx
var AvatarWithName = __webpack_require__(7869);
// EXTERNAL MODULE: ./src/utils/datetime.ts + 1 modules
var datetime = __webpack_require__(61297);
// EXTERNAL MODULE: ./src/components/PopOver/index.tsx + 2 modules
var PopOver = __webpack_require__(20951);
// EXTERNAL MODULE: ./src/constants/enum/comment.ts
var comment = __webpack_require__(44352);
// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./src/constants/image.ts
var constants_image = __webpack_require__(24435);
// EXTERNAL MODULE: ./src/components/Share/index.tsx + 6 modules
var Share = __webpack_require__(70731);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/url-join/lib/url-join.js
var url_join = __webpack_require__(26509);
// EXTERNAL MODULE: ./src/modules/common/ProjectDetail/ReviewItem/BoxReply.tsx
var BoxReply = __webpack_require__(18858);
// EXTERNAL MODULE: ./src/modules/common/ProjectDetail/ReviewItem/ListReplyReview/FormReplyReview/index.tsx + 1 modules
var FormReplyReview = __webpack_require__(8971);
// EXTERNAL MODULE: ./src/modules/common/ProjectDetail/ReviewItem/ReviewDetailRate.tsx
var ReviewDetailRate = __webpack_require__(38762);
// EXTERNAL MODULE: ./src/modules/common/ProjectDetail/ReviewItem/ReviewDetailTextContent.tsx
var ReviewDetailTextContent = __webpack_require__(27083);
;// CONCATENATED MODULE: ./src/modules/common/ProjectDetail/ReviewItem/index.tsx
// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";



















const ListReplyReview = dynamic_default()(__webpack_require__.e(/* import() */ 739).then(__webpack_require__.bind(__webpack_require__, 40739)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(40739)
            ]
    },
    ssr: false
});
const ReviewDetailFileList = dynamic_default()(__webpack_require__.e(/* import() */ 936).then(__webpack_require__.bind(__webpack_require__, 10936)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10936)
            ]
    },
    ssr: false
});
const ReviewDetailAction = dynamic_default()(__webpack_require__.e(/* import() */ 9082).then(__webpack_require__.bind(__webpack_require__, 59082)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(59082)
            ]
    },
    ssr: false
});
const ReviewItem = (param)=>{
    let { data , itemIndex , mounted  } = param;
    const { currentShowFormReply , setCurrentShowFormReport , currentRefItem  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const { user , login  } = (0,useAuth/* useAuth */.a)();
    const urlUserAvatar = (0,react.useMemo)(()=>{
        var _data_createdBy;
        if (data === null || data === void 0 ? void 0 : (_data_createdBy = data.createdBy) === null || _data_createdBy === void 0 ? void 0 : _data_createdBy.avatar) {
            var _data_createdBy1, _data_createdBy2, _data_createdBy3;
            return (data === null || data === void 0 ? void 0 : (_data_createdBy1 = data.createdBy) === null || _data_createdBy1 === void 0 ? void 0 : _data_createdBy1.avatar.includes(environment/* MEDIA_URL */.eR)) ? (0,utils/* resizeOnFlyUrl */.Li)({
                uri: data === null || data === void 0 ? void 0 : (_data_createdBy2 = data.createdBy) === null || _data_createdBy2 === void 0 ? void 0 : _data_createdBy2.avatar.replace(environment/* MEDIA_URL */.eR, ""),
                width: 64,
                height: 64,
                gravity: "ce",
                resizingType: "auto"
            }) : data === null || data === void 0 ? void 0 : (_data_createdBy3 = data.createdBy) === null || _data_createdBy3 === void 0 ? void 0 : _data_createdBy3.avatar;
        } else if (data === null || data === void 0 ? void 0 : data.nickName) {
            return null;
        } else return "".concat(environment/* STATIC_DOMAIN */.xm, "/").concat(constants_image/* DEFAULT_USER_AVATAR */._D);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: data._id,
        style: {
            boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.04)"
        },
        ref: (ele)=>{
            currentRefItem.current[itemIndex] = ele;
        },
        className: "flex items-start gap-x-3 p-4 bg-white md:rounded-xl w-full overflow-auto border-b border-b-gray-200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarWithName/* default */.Z, {
                imageClass: "md:!w-14 md:!h-14 !w-8 !h-8",
                imageProps: {
                    resizeOnFly: false
                },
                className: "flex-0 ",
                avatarOnly: true,
                alt: data.nickName ? data.nickName : "Ẩn danh",
                name: data.nickName,
                src: urlUserAvatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-1 gap-x-3 overflow-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-grey-700 font-semibold md:flex items-center flex-1 justify-start table-cell align-middle",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "md:line-clamp-1 break-word align-middle",
                                                children: [
                                                    data.nickName ? data.nickName : "Ẩn danh",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml-1.5 text-grey-600 text-fs-14 font-normal whitespace-nowrap align-middle",
                                                children: data.type === comment/* CommentTypeEnum.REVIEW */.I.REVIEW ? "đ\xe3 viết review" : "đ\xe3 đặt c\xe2u hỏi"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: (0,clsx_m/* default */.Z)("mrv  text-fs-24 text-grey-400  ml-1.5 cursor-pointe flex-0 align-middle", data.type === comment/* CommentTypeEnum.REVIEW */.I.REVIEW ? "mrv-review" : "mrv-contact_support")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-0 flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* default */.Z, {
                                                shareUrl: (0,url_join/* default */.Z)(environment/* APP_BASE_URL */.E5, "review", data._id),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "mrv mrv-share text-fs-24 ml-1.5 cursor-pointer"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                                                dropdownClassName: "px-2 py-2.5 rounded-lg shadow-light-2",
                                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center w-56 cursor-pointer",
                                                        onClick: ()=>user ? setCurrentShowFormReport(data._id) : login(),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "mrv mrv-report text-fs-20 mr-2 cursor-pointer"
                                                            }),
                                                            "B\xe1o c\xe1o b\xe0i viết"
                                                        ]
                                                    })
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "mrv mrv-more_vert text-fs-24 ml-1.5 cursor-pointer"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-grey-500 text-fs-14",
                                children: mounted ? (0,datetime/* getRelativeTime */.ni)(new Date(data === null || data === void 0 ? void 0 : data.publishedAt)) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full overflow-auto reply-review-list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewDetailRate/* default */.Z, {
                                data: data
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewDetailTextContent/* default */.Z, {
                                data: data
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewDetailFileList, {
                                data: data
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewDetailAction, {
                                data: data
                            }),
                            currentShowFormReply ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxReply/* default */.Z, {
                                data: data
                            }),
                            currentShowFormReply === data._id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormReplyReview/* default */.Z, {
                                data: data,
                                reviewItem: data,
                                reviewIndex: itemIndex
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListReplyReview, {
                                data: data,
                                reviewIndex: itemIndex
                            })
                        ]
                    })
                ]
            })
        ]
    }, data._id);
};
/* harmony default export */ var ProjectDetail_ReviewItem = (ReviewItem);

;// CONCATENATED MODULE: ./src/modules/common/ProjectDetail/ReviewItem/EmptyReviewList.tsx


const EmptyReviewList = ()=>{
    const { query  } = (0,router.useRouter)();
    return query.voteScore || query.comment || query.type || query.haveMedia ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-[220px] rounded-lg bg-white flex flex-col items-center justify-center md:mt-16",
        style: {
            boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.04)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "mrv mrv-building text-grey-200 text-[68px]"
            }),
            query.comment ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2 text-gray-500 text-fs-14",
                        children: "Kh\xf4ng c\xf3 kết quả ph\xf9 hợp với từ kh\xf3a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center px-2",
                        children: [
                            '"',
                            query.comment,
                            '"'
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 text-gray-500 text-fs-14",
                children: "Kh\xf4ng c\xf3 kết quả"
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex-[1_1_auto] flex flex-col overflow-auto w-full gap-3 items-center mt-8 md:mt-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-fs-24 font-semibold text-grey-400",
                children: "Chưa c\xf3 b\xe0i review n\xe0o"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-grey-600 text-center",
                children: [
                    "H\xe3y để lại ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-grey-700 font-medium",
                        children: "Review"
                    }),
                    " ",
                    "hoặc ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-grey-700 font-medium",
                        children: "C\xe2u hỏi"
                    }),
                    " về dự \xe1n n\xe0y để ch\xfang ta c\xf9ng b\xe0n luận."
                ]
            })
        ]
    });
};
/* harmony default export */ var ReviewItem_EmptyReviewList = (EmptyReviewList);

// EXTERNAL MODULE: ./src/api/endpoint/reviews/get-reviews-reactions.ts
var get_reviews_reactions = __webpack_require__(85080);
// EXTERNAL MODULE: ./src/context/device.context.tsx
var device_context = __webpack_require__(99757);
;// CONCATENATED MODULE: ./src/modules/Desktop/ProjectDetail/BoxReview.tsx








const ModalAddReviewProjectDetailMobile = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(8762), __webpack_require__.e(2678), __webpack_require__.e(2540), __webpack_require__.e(6140), __webpack_require__.e(6509)]).then(__webpack_require__.bind(__webpack_require__, 36509)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(36509)
            ]
    },
    ssr: false
});
const ModalAddReviewProjectDetail = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(8762), __webpack_require__.e(2678), __webpack_require__.e(2540), __webpack_require__.e(6140), __webpack_require__.e(2296)]).then(__webpack_require__.bind(__webpack_require__, 12296)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12296)
            ]
    },
    ssr: false
});
const BoxReview = ()=>{
    const { user  } = (0,useAuth/* useAuth */.a)();
    const [openModalReview, setOpenModalReview] = (0,react.useState)(false);
    const [isOpenSelectFile, setIsOpenSelectFile] = (0,react.useState)(false);
    const { project , refUpload  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    (0,react.useEffect)(()=>{
        if (isOpenSelectFile) {
            var _refUpload_current;
            refUpload === null || refUpload === void 0 ? void 0 : (_refUpload_current = refUpload.current) === null || _refUpload_current === void 0 ? void 0 : _refUpload_current.click();
        }
    }, [
        isOpenSelectFile,
        refUpload
    ]);
    const { isMobile  } = (0,react.useContext)(device_context/* DeviceContext */.T);
    var _user_name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white rounded-xl border border-solid border-grey-200 p-4 flex items-center gap-3 my-4 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarWithName/* default */.Z, {
                        imageProps: {
                            resizeOnFly: false
                        },
                        src: (user === null || user === void 0 ? void 0 : user.avatar) ? user === null || user === void 0 ? void 0 : user.avatar : (user === null || user === void 0 ? void 0 : user.name) ? null : constants_image/* DEFAULT_IMAGE_CARD */.mq,
                        name: (_user_name = user === null || user === void 0 ? void 0 : user.name) !== null && _user_name !== void 0 ? _user_name : "Ẩn danh",
                        avatarOnly: true,
                        imageClass: "!w-10 !h-10",
                        textClass: "!text-white font-medium select-none",
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border border-solid border-grey-200 p-3 text-fs-14 text-grey-600 rounded-full w-full h-10 flex items-center md:cursor-pointer",
                        onClick: ()=>setOpenModalReview(true),
                        children: "Bạn review g\xec đi ..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-image text-green-400 text-fs-32 cursor-pointer",
                        onClick: ()=>{
                            setOpenModalReview(true);
                            setIsOpenSelectFile(true);
                        }
                    })
                ]
            }),
            openModalReview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAddReviewProjectDetailMobile, {
                    open: openModalReview,
                    handleClose: ()=>{
                        setOpenModalReview(false);
                        setIsOpenSelectFile(false);
                    },
                    project: project,
                    reviewType: 1
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAddReviewProjectDetail, {
                    open: openModalReview,
                    handleClose: ()=>{
                        setOpenModalReview(false);
                        setIsOpenSelectFile(false);
                    },
                    project: project,
                    reviewType: 1
                })
            }) : null
        ]
    });
};
/* harmony default export */ var ProjectDetail_BoxReview = (BoxReview);

// EXTERNAL MODULE: ./src/modules/common/ProjectDetail/ReviewItem/ReportModal.tsx + 1 modules
var ReportModal = __webpack_require__(54973);
;// CONCATENATED MODULE: ./src/modules/common/ProjectDetail/ListReview.tsx














const ListReview = (param)=>{
    let { reviewFilter  } = param;
    var _projectListVote_results, _projectListVote_results1, _projectListVote_results2;
    const { projectListVote , setProjectListVote , project , listReviewsIds , setListReviewIds , listReviewReactions , setListReviewReactions  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const { userDataHeader  } = (0,useAuth/* useAuth */.a)();
    const { query: { reviewId , voteScore , type , haveMedia , comment  }  } = (0,router.useRouter)();
    const handleGetListReviewsReactions = async ()=>{
        const res = await (0,get_reviews_reactions/* getReviewsReactions */.f)(listReviewsIds, userDataHeader);
        if (res) {
            setListReviewReactions([
                ...listReviewReactions,
                ...res
            ]);
        }
    };
    (0,react.useEffect)(()=>{
        if (listReviewsIds === null || listReviewsIds === void 0 ? void 0 : listReviewsIds.length) {
            handleGetListReviewsReactions();
        }
    }, [
        listReviewsIds
    ]);
    const onLoadMore = async ()=>{
        // getListProjectReview();
        const res = await (0,get_list_review_project/* getListReviewProject */.b)(project._id, (0,utils/* skipNullParams */.Jm)({
            page: projectListVote.page + 1,
            sort: "publishedAt:desc",
            voteScore: voteScore ? Number("".concat(voteScore)) : null,
            type: type ? Number("".concat(type)) : null,
            haveMedia: haveMedia ? Boolean("".concat(haveMedia)) : null,
            comment: comment
        }), userDataHeader);
        if (res) {
            var _res_results;
            let listIds = [];
            res === null || res === void 0 ? void 0 : (_res_results = res.results) === null || _res_results === void 0 ? void 0 : _res_results.map((item)=>{
                var _item_replies;
                listIds.push(item === null || item === void 0 ? void 0 : item._id);
                if ((_item_replies = item.replies) === null || _item_replies === void 0 ? void 0 : _item_replies.length) {
                    item.replies.map((rep)=>{
                        listIds.push(rep._id);
                    });
                }
            });
            setListReviewIds(listIds);
        }
        setProjectListVote({
            ...res,
            results: [
                ...projectListVote.results,
                ...res.results
            ]
        });
    };
    (0,react.useEffect)(()=>{
        if (reviewId) {
            const element = document.getElementById("".concat(reviewId));
            if (element) {
                element.scrollIntoView();
            }
        }
    }, [
        reviewId
    ]);
    const handleSyncReaction = (0,react.useCallback)(async ()=>{
        if (userDataHeader) {
            const syncData = await (0,get_list_review_project/* getListReviewProject */.b)(project._id, (0,utils/* skipNullParams */.Jm)({
                sort: "publishedAt:desc",
                voteScore: voteScore ? Number("".concat(voteScore)) : null,
                type: type ? Number("".concat(type)) : null,
                haveMedia: haveMedia ? Boolean("".concat(haveMedia)) : null,
                comment: comment
            }), userDataHeader);
            setProjectListVote(syncData);
        }
    }, [
        comment,
        haveMedia,
        project._id,
        setProjectListVote,
        type,
        userDataHeader,
        voteScore
    ]);
    const [mounted, setMounted] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (!projectListVote) handleSyncReaction();
    }, [
        handleSyncReaction,
        projectListVote
    ]);
    (0,react.useEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("overflow-auto flex-[1_1_auto] ", (projectListVote === null || projectListVote === void 0 ? void 0 : projectListVote.totalResults) ? "bg-grey-50" : "bg-white md:bg-grey-50"),
        children: [
            reviewFilter,
            (projectListVote === null || projectListVote === void 0 ? void 0 : projectListVote.totalResults) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetail_BoxReview, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                        dataLength: (projectListVote === null || projectListVote === void 0 ? void 0 : (_projectListVote_results = projectListVote.results) === null || _projectListVote_results === void 0 ? void 0 : _projectListVote_results.length) || 0,
                        next: onLoadMore,
                        hasMore: (projectListVote === null || projectListVote === void 0 ? void 0 : (_projectListVote_results1 = projectListVote.results) === null || _projectListVote_results1 === void 0 ? void 0 : _projectListVote_results1.length) < (projectListVote === null || projectListVote === void 0 ? void 0 : projectListVote.totalResults),
                        className: " flex-[1_1_auto] flex flex-col md:gap-4 gap-1 overflow-auto w-full",
                        loader: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-4 flex items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dot-flashing"
                            })
                        }),
                        children: (_projectListVote_results2 = projectListVote.results) === null || _projectListVote_results2 === void 0 ? void 0 : _projectListVote_results2.map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetail_ReviewItem, {
                                data: item,
                                itemIndex: index,
                                mounted: mounted
                            }, item._id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModal/* default */.Z, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem_EmptyReviewList, {})
        ]
    });
};
/* harmony default export */ var ProjectDetail_ListReview = (ListReview);


/***/ }),

/***/ 56590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ PageSlug; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/utils/fetch-api.ts + 1 modules
var fetch_api = __webpack_require__(65255);
// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./src/constants/request-method.ts
var request_method = __webpack_require__(17028);
;// CONCATENATED MODULE: ./src/api/endpoint/project/tracking-project.ts



const trackingProject = async (id)=>{
    const path = "v1/projects/tracking/".concat(id);
    const response = await (0,fetch_api/* createFetcher */.gt)(()=>({
            apiUrl: environment/* MEEY_REVIEW_API_URL */.HG
        }))(request_method/* default.POST */.Z.POST, path, null, {});
    return response;
};

// EXTERNAL MODULE: ./src/context/device.context.tsx
var device_context = __webpack_require__(99757);
// EXTERNAL MODULE: ./src/context/project.context.tsx
var project_context = __webpack_require__(12482);
;// CONCATENATED MODULE: ./src/api/endpoint/project/check-follow-project.ts



const checkFollowProject = async (params, token)=>{
    const path = "v1/follows/check";
    const response = await (0,fetch_api/* createFetcher */.gt)(()=>({
            apiUrl: environment/* MEEY_REVIEW_API_URL */.HG
        }))(request_method/* default.POST */.Z.POST, path, params, {
        token
    });
    return response;
};

// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 2 modules
var useAuth = __webpack_require__(33172);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/Desktop/ProjectDetail/HeaderDetail.tsx
var HeaderDetail = __webpack_require__(15085);
;// CONCATENATED MODULE: ./src/api/endpoint/project/create-follow-project.ts



const createFollowProject = async (params, token)=>{
    const path = "v1/follows";
    const response = await (0,fetch_api/* createFetcher */.gt)(()=>({
            apiUrl: environment/* MEEY_REVIEW_API_URL */.HG
        }))(request_method/* default.POST */.Z.POST, path, params, {
        token
    });
    return response;
};

// EXTERNAL MODULE: ./src/components/Button.tsx + 1 modules
var Button = __webpack_require__(40364);
// EXTERNAL MODULE: ./src/components/MeeyImage.tsx
var MeeyImage = __webpack_require__(3524);
// EXTERNAL MODULE: ./src/components/MeeyRate.tsx
var MeeyRate = __webpack_require__(14759);
// EXTERNAL MODULE: ./src/components/PopOver/index.tsx + 2 modules
var PopOver = __webpack_require__(20951);
// EXTERNAL MODULE: ./src/constants/common-constant.ts
var common_constant = __webpack_require__(17785);
// EXTERNAL MODULE: ./src/constants/enum/comment.ts
var comment = __webpack_require__(44352);
// EXTERNAL MODULE: ./src/constants/project-constant.ts
var project_constant = __webpack_require__(18825);
// EXTERNAL MODULE: ./src/utils/index.ts + 2 modules
var utils = __webpack_require__(67650);
// EXTERNAL MODULE: ./src/components/Share/index.tsx + 6 modules
var Share = __webpack_require__(70731);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/url-join/lib/url-join.js
var url_join = __webpack_require__(26509);
;// CONCATENATED MODULE: ./src/modules/Desktop/ProjectDetail/HeaderProjectInfo.tsx


















const ModalAddReviewProjectDetail = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(8762), __webpack_require__.e(2678), __webpack_require__.e(2540), __webpack_require__.e(6140), __webpack_require__.e(2296)]).then(__webpack_require__.bind(__webpack_require__, 12296)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12296)
            ]
    },
    ssr: false
});
const HeaderProjectInfo = (param)=>{
    let { project , isFollowProject  } = param;
    var _project_banner, _project_banner1, _project_logo, _project_logo1, _project_title, _project_voteScore, _project_voteScore1;
    const { setCheckFollowProject  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const { token , login  } = (0,useAuth/* useAuth */.a)();
    // const [mounted, setMounted] = useState(false);
    const [loadingFollow, setLoadingFollow] = (0,react.useState)(false);
    const [openModalReview, setOpenModalReview] = (0,react.useState)(false);
    const [reviewType, setReviewType] = (0,react.useState)(comment/* CommentTypeEnum.REVIEW */.I.REVIEW);
    const { asPath  } = (0,next_router.useRouter)();
    // useEffect(() => {
    //   setMounted(true);
    // }, []);
    const handleFollowProject = async ()=>{
        if (!token) {
            login();
        } else {
            setLoadingFollow(true);
            const res = await createFollowProject({
                project: project === null || project === void 0 ? void 0 : project._id,
                status: isFollowProject ? common_constant/* FOLLOW_PROJECT_STATUS.UN_FOLLOW */.l8.UN_FOLLOW : common_constant/* FOLLOW_PROJECT_STATUS.FOLLOW */.l8.FOLLOW
            }, token);
            setLoadingFollow(false);
            if (res) {
                setCheckFollowProject(!isFollowProject);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full h-fit bg-white shadow-light-1 rounded-b-xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                        src: (project === null || project === void 0 ? void 0 : (_project_banner = project.banner) === null || _project_banner === void 0 ? void 0 : _project_banner.uri) || "/images/default_banner_project.png",
                        resizeOnFly: !!(project === null || project === void 0 ? void 0 : (_project_banner1 = project.banner) === null || _project_banner1 === void 0 ? void 0 : _project_banner1.uri),
                        resizeOptions: {
                            width: 1096,
                            height: 274
                        },
                        alt: "banner" + project.title,
                        className: "object-cover h-[274px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " w-full mt-[-108px] ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between gap-6 px-4 py-6 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " flex items-end gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                            src: (project === null || project === void 0 ? void 0 : project.logo) ? project === null || project === void 0 ? void 0 : (_project_logo = project.logo) === null || _project_logo === void 0 ? void 0 : _project_logo.uri : "".concat(environment/* STATIC_DOMAIN */.xm, "/").concat(project_constant/* DEFAULT_LOGO_PROJECT */.J3),
                                            alt: project === null || project === void 0 ? void 0 : project.title,
                                            resizeOnFly: !!(project === null || project === void 0 ? void 0 : (_project_logo1 = project.logo) === null || _project_logo1 === void 0 ? void 0 : _project_logo1.uri),
                                            resizeOptions: {
                                                width: 0,
                                                height: 168
                                            },
                                            className: "rounded-full w-[10.5rem] h-[10.5rem] border-2 border-solid border-grey-50 object-contain bg-white aspect-square"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                                                    trigger: "hover",
                                                    dropdownClassName: "mt-2 !p-0 rounded !bg-transparent",
                                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word",
                                                        children: project === null || project === void 0 ? void 0 : project.title
                                                    }),
                                                    position: "top-left",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-fs-28 font-semibold text-grey-700",
                                                        children: (project === null || project === void 0 ? void 0 : (_project_title = project.title) === null || _project_title === void 0 ? void 0 : _project_title.length) > 40 ? (project === null || project === void 0 ? void 0 : project.title.substring(0, 40)) + "..." : project === null || project === void 0 ? void 0 : project.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-base text-grey-500",
                                                    children: (0,utils/* convertAddressNoStreet */.NL)(project) || "----"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (project === null || project === void 0 ? void 0 : project.totalHotReview) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute bottom-2 right-4 flex flex-col items-center gap-[2px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-fs-48 leading-[58px] font-semibold text-grey-700",
                                            children: (project === null || project === void 0 ? void 0 : project.voteScore) ? Number.isInteger(project === null || project === void 0 ? void 0 : project.voteScore) ? project === null || project === void 0 ? void 0 : project.voteScore : project === null || project === void 0 ? void 0 : (_project_voteScore = project.voteScore) === null || _project_voteScore === void 0 ? void 0 : _project_voteScore.toFixed(1) : null
                                        }),
                                        (project === null || project === void 0 ? void 0 : project.voteScore) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyRate/* default */.Z, {
                                            disable: true,
                                            value: Number.isInteger(project === null || project === void 0 ? void 0 : project.voteScore) ? project === null || project === void 0 ? void 0 : project.voteScore : Number(project === null || project === void 0 ? void 0 : (_project_voteScore1 = project.voteScore) === null || _project_voteScore1 === void 0 ? void 0 : _project_voteScore1.toFixed(1)),
                                            itemClassName: "!text-fs-20",
                                            className: "h-4 items-center"
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-fs-12 text-grey-400 font-medium",
                                            children: [
                                                project === null || project === void 0 ? void 0 : project.totalHotReview,
                                                " reviews"
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "border-t border-solid border-grey-100 p-4 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "primary",
                                btnType: "filled",
                                onClick: ()=>{
                                    setOpenModalReview(true);
                                    setReviewType(comment/* CommentTypeEnum.REVIEW */.I.REVIEW);
                                },
                                prefixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-review text-fs-18",
                                    children: " "
                                }),
                                className: "h-11",
                                children: "Viết review"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "meey-button meey-button-filled !bg-purple-500 hover:!text-white py-2.5 px-4 h-11 flex items-center gap-1 !border-none",
                                onClick: ()=>{
                                    setOpenModalReview(true);
                                    setReviewType(comment/* CommentTypeEnum.QUESTION */.I.QUESTION);
                                },
                                prefixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-contact_support text-fs-20"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-fs-16 font-semibold",
                                    children: "Đặt c\xe2u hỏi"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                                trigger: "hover",
                                dropdownClassName: "mt-2 !p-0 rounded !bg-transparent",
                                content: !isFollowProject ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word",
                                    children: "“H\xf3ng” sẽ gi\xfap bạn cập nhật li\xean tục review mới của dự \xe1n n\xe0y!"
                                }) : null,
                                position: "bottom-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    className: "meey-button meey-button-grey meey-button-filled py-2.5 px-4 h-11 flex items-center gap-1",
                                    onClick: handleFollowProject,
                                    loading: loadingFollow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mrv mrv-hearing text-fs-20"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-fs-16 font-semibold",
                                            children: isFollowProject ? "Đ\xe3 h\xf3ng" : "H\xf3ng"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* default */.Z, {
                        shareUrl: (0,url_join/* default */.Z)(environment/* APP_BASE_URL */.E5, asPath),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "meey-button meey-button-grey meey-button-filled h-11 w-11 flex items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "mrv mrv-share text-fs-20"
                            })
                        })
                    })
                ]
            }),
            openModalReview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAddReviewProjectDetail, {
                open: openModalReview,
                handleClose: ()=>setOpenModalReview(false),
                project: project,
                reviewType: reviewType
            }) : null
        ]
    });
};
/* harmony default export */ var ProjectDetail_HeaderProjectInfo = (HeaderProjectInfo);

// EXTERNAL MODULE: ./src/hooks/useChangeRoute.ts
var useChangeRoute = __webpack_require__(28309);
// EXTERNAL MODULE: ./src/vendor/click-outside/index.ts + 3 modules
var click_outside = __webpack_require__(23199);
// EXTERNAL MODULE: ./src/vendor/scroll-locker/useScrollLocker.tsx + 4 modules
var useScrollLocker = __webpack_require__(77027);
;// CONCATENATED MODULE: ./src/modules/common/ProjectDetail/InputSearchReview.tsx
// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";








const suggestItem = [
    "Vị tr\xed",
    "Chủ đầu tư",
    "Gi\xe1 b\xe1n",
    "Khu\xf4n vi\xean",
    "Giấy tờ ph\xe1p l\xfd",
    "B\xe3i đậu xe"
];
const InputSearchReview = (param)=>{
    let { className  } = param;
    const router = (0,next_router.useRouter)();
    const [val, setVal] = (0,react.useState)("");
    const [open, setOpen] = (0,react.useState)(null);
    const [focus, setFocus] = (0,react.useState)(false);
    const inputRef = (0,react.useRef)(null);
    const { loading  } = (0,useChangeRoute/* useChangeRoute */.r)();
    (0,react.useEffect)(()=>{
        setVal(router.query.comment || "");
        setOpen(false);
    }, [
        router.query
    ]);
    (0,react.useEffect)(()=>{
        if (focus) (0,useScrollLocker/* lockScroll */.dg)();
        else (0,useScrollLocker/* unlockScroll */.pX)();
        return ()=>{
            (0,useScrollLocker/* unlockScroll */.pX)();
        };
    }, [
        focus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(click_outside/* default */.Z, {
        active: open,
        onClick: ()=>{
            setOpen(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative md:w-fit",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center md:w-[21.5rem] rounded-full border px-3 py-1 bg-white text-grey-600 relative duration-300",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "mrv mrv-search text-fs-20 mr-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            placeholder: "T\xecm nội dung review bạn quan t\xe2m...",
                            value: val,
                            ref: inputRef,
                            onFocus: ()=>{
                                setFocus(true);
                                setOpen(true);
                            },
                            onBlur: ()=>setFocus(false),
                            className: "h-[28px] mr-5 w-full text-base",
                            onChange: (e)=>setVal(e.target.value.slice(0, 100)),
                            onKeyUp: (e)=>{
                                var _e_target_value;
                                if (e.key === "Enter" && !loading && (!e.target.value && router.query.comment || e.target.value)) router.push({
                                    query: (0,utils/* skipNullParams */.Jm)({
                                        ...router.query,
                                        comment: (_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.trim().replace(/\s\s+/g, " ")
                                    })
                                });
                            }
                        })
                    ]
                }),
                val ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-1 right-3 cursor-pointer ",
                    onClick: ()=>{
                        if (!loading) if (!focus) router.push({
                            query: (0,utils/* skipNullParams */.Jm)({
                                ...router.query,
                                comment: null
                            })
                        });
                        else {
                            setVal("");
                            inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.focus();
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-cancel text-fs-20"
                    })
                }) : null,
                open ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-[336px] mt-2 absolute bg-white z-[2500] p-4 shadow-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-semibold text-grey-800 mb-3",
                            children: "Chủ đề được quan t\xe2m"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-wrap gap-2",
                            children: suggestItem.map((item)=>{
                                const isActive = val.toLocaleLowerCase().includes(item.toLocaleLowerCase());
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("border border-grey-200 px-3 py-1 bg-grey-50 text-fs-12 rounded-full font-medium cursor-pointer select-none", isActive ? "!border-blue-500" : "border-grey-200"),
                                    onClick: ()=>{
                                        // router.push({
                                        //   query: skipNullParams({
                                        //     ...router.query,
                                        //     comment: item,
                                        //   }),
                                        // });
                                        if (!isActive) setVal((val + item + " ").slice(0, 100));
                                        inputRef.current.focus();
                                    },
                                    children: item
                                }, item);
                            })
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var ProjectDetail_InputSearchReview = (InputSearchReview);

;// CONCATENATED MODULE: ./src/modules/Desktop/ProjectDetail/HeaderProjectScroll.tsx

















const HeaderProjectScroll_ModalAddReviewProjectDetail = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(8762), __webpack_require__.e(2678), __webpack_require__.e(2540), __webpack_require__.e(6140), __webpack_require__.e(2296)]).then(__webpack_require__.bind(__webpack_require__, 12296)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12296)
            ]
    },
    ssr: false
});
const HeaderProjectScroll = (param)=>{
    let { project , isFollowProject  } = param;
    var _project_logo, _project_logo1, _project_title, _project_voteScore;
    const [openModalReview, setOpenModalReview] = (0,react.useState)(false);
    const [reviewType, setReviewType] = (0,react.useState)(comment/* CommentTypeEnum.REVIEW */.I.REVIEW);
    const { setCheckFollowProject  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const { asPath  } = (0,next_router.useRouter)();
    const { token , login  } = (0,useAuth/* useAuth */.a)();
    const handleFollowProject = async ()=>{
        if (!token) {
            login();
        } else {
            const res = await createFollowProject({
                project: project === null || project === void 0 ? void 0 : project._id,
                status: isFollowProject ? common_constant/* FOLLOW_PROJECT_STATUS.UN_FOLLOW */.l8.UN_FOLLOW : common_constant/* FOLLOW_PROJECT_STATUS.FOLLOW */.l8.FOLLOW
            }, token);
            if (res) {
                setCheckFollowProject(!isFollowProject);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full h-fit bg-white shadow-light-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between gap-6 py-2 layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                src: (project === null || project === void 0 ? void 0 : project.logo) ? project === null || project === void 0 ? void 0 : (_project_logo = project.logo) === null || _project_logo === void 0 ? void 0 : _project_logo.uri : "".concat(environment/* STATIC_DOMAIN */.xm, "/").concat(project_constant/* DEFAULT_LOGO_PROJECT */.J3),
                                alt: project === null || project === void 0 ? void 0 : project.title,
                                resizeOnFly: !!(project === null || project === void 0 ? void 0 : (_project_logo1 = project.logo) === null || _project_logo1 === void 0 ? void 0 : _project_logo1.uri),
                                resizeOptions: {
                                    width: 0,
                                    height: 36
                                },
                                className: "rounded-full h-9 w-9 border-2 border-solid border-grey-50 object-contain"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                                trigger: "hover",
                                dropdownClassName: "mt-2 !p-0 rounded !bg-transparent",
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word",
                                    children: project === null || project === void 0 ? void 0 : project.title
                                }),
                                position: "bottom-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-fs-16 font-semibold text-grey-700",
                                    children: (project === null || project === void 0 ? void 0 : (_project_title = project.title) === null || _project_title === void 0 ? void 0 : _project_title.length) > 80 ? (project === null || project === void 0 ? void 0 : project.title.substring(0, 80)) + "..." : project === null || project === void 0 ? void 0 : project.title
                                })
                            })
                        ]
                    }),
                    (project === null || project === void 0 ? void 0 : project.totalHotReview) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            (project === null || project === void 0 ? void 0 : project.voteScore) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-fs-20 font-semibold text-grey-700",
                                        children: Number.isInteger(project === null || project === void 0 ? void 0 : project.voteScore) ? project === null || project === void 0 ? void 0 : project.voteScore : project === null || project === void 0 ? void 0 : (_project_voteScore = project.voteScore) === null || _project_voteScore === void 0 ? void 0 : _project_voteScore.toFixed(1)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-star text-[#FFC633] text-fs-20"
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-fs-16 text-grey-700",
                                children: [
                                    "(",
                                    project === null || project === void 0 ? void 0 : project.totalHotReview,
                                    " reviews)"
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-t border-solid border-grey-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-2 flex items-center justify-between layout",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetail_InputSearchReview, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-4",
                            children: [
                                openModalReview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderProjectScroll_ModalAddReviewProjectDetail, {
                                    open: openModalReview,
                                    handleClose: ()=>setOpenModalReview(false),
                                    project: project,
                                    reviewType: reviewType
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "primary",
                                    btnType: "filled",
                                    onClick: ()=>{
                                        setOpenModalReview(true);
                                        setReviewType(comment/* CommentTypeEnum.REVIEW */.I.REVIEW);
                                    },
                                    className: "!h-9",
                                    prefixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-review text-fs-18",
                                        children: " "
                                    }),
                                    children: "Viết review"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    className: "meey-button meey-button-filled !bg-purple-500 hover:!text-white py-2.5 px-4 h-9 flex items-center gap-1 !border-none",
                                    onClick: ()=>{
                                        setOpenModalReview(true);
                                        setReviewType(comment/* CommentTypeEnum.QUESTION */.I.QUESTION);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mrv mrv-contact_support text-fs-18"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-fs-14 font-semibold",
                                            children: "Đặt c\xe2u hỏi"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                                    trigger: "hover",
                                    dropdownClassName: "mt-2 !p-0 rounded !bg-transparent",
                                    content: !isFollowProject ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word",
                                        children: "“H\xf3ng” sẽ gi\xfap bạn cập nhật li\xean tục review mới của dự \xe1n n\xe0y!"
                                    }) : null,
                                    position: "bottom-left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        className: "meey-button meey-button-grey meey-button-filled py-2.5 px-4 h-9 flex items-center gap-1",
                                        onClick: handleFollowProject,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "mrv mrv-hearing text-fs-18"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-fs-14 font-semibold",
                                                children: isFollowProject ? "Đ\xe3 h\xf3ng" : "H\xf3ng"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* default */.Z, {
                                    shareUrl: (0,url_join/* default */.Z)(environment/* APP_BASE_URL */.E5, asPath),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "meey-button meey-button-grey meey-button-filled h-9 w-9 flex items-center justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mrv mrv-share text-fs-18"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ProjectDetail_HeaderProjectScroll = (HeaderProjectScroll);

;// CONCATENATED MODULE: ./src/modules/Desktop/ProjectDetail/ReviewFilter.tsx
// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";








const FILTER_REVIEWS = [
    // {
    //   key: "type",
    //   value: "1",
    //   label: "Review",
    //   resultKey: "totalReview",
    // },
    {
        key: "voteScore",
        value: "5",
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "5 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "mrv mrv-star text-yellow-500"
                })
            ]
        }),
        resultKey: "5"
    },
    {
        key: "voteScore",
        value: "4",
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "4 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "mrv mrv-star text-yellow-500"
                })
            ]
        }),
        resultKey: "4"
    },
    {
        key: "voteScore",
        value: "3",
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "3 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "mrv mrv-star text-yellow-500"
                })
            ]
        }),
        resultKey: "3"
    },
    {
        key: "voteScore",
        value: "2",
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "2 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "mrv mrv-star text-yellow-500"
                })
            ]
        }),
        resultKey: "2"
    },
    {
        key: "voteScore",
        value: "1",
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "1 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "mrv mrv-star text-yellow-500"
                })
            ]
        }),
        resultKey: "1"
    },
    // {
    //   key: "type",
    //   value: "2",
    //   label: "Câu hỏi",
    //   resultKey: "totalQuestion",
    // },
    {
        key: "haveMedia",
        value: "true",
        label: "C\xf3 h\xecnh ảnh/Video/File",
        resultKey: "media"
    }
];
const ReviewFilter = ()=>{
    const { numberNewReview  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const router = (0,next_router.useRouter)();
    const { loading  } = (0,useChangeRoute/* useChangeRoute */.r)();
    const handleFilter = (key, value)=>{
        router.push({
            query: (0,utils/* skipNullParams */.Jm)({
                id: router.query.id,
                comment: router.query.comment,
                [key]: value
            })
        });
    };
    const { query  } = router;
    var _numberNewReview_totalReview, _numberNewReview_totalQuestion, _numberNewReview_totalReview1, _numberNewReview_totalQuestion1;
    return ((_numberNewReview_totalReview = numberNewReview.totalReview) !== null && _numberNewReview_totalReview !== void 0 ? _numberNewReview_totalReview : 0) + ((_numberNewReview_totalQuestion = numberNewReview.totalQuestion) !== null && _numberNewReview_totalQuestion !== void 0 ? _numberNewReview_totalQuestion : 0) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (numberNewReview === null || numberNewReview === void 0 ? void 0 : numberNewReview.today) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-grey-600 text-fs-20 font-semibold mb-4",
                children: [
                    "C\xf3 ",
                    numberNewReview === null || numberNewReview === void 0 ? void 0 : numberNewReview.today,
                    " review mới h\xf4m nay",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-red-600",
                        children: "•"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap gap-2 mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: ()=>{
                            if (!loading) router.push((0,utils/* skipNullParams */.Jm)({
                                comment: router.query.comment,
                                query: {
                                    id: router.query.id
                                }
                            }));
                        },
                        className: (0,clsx_m/* default */.Z)("text-grey-600 px-3 py-1 rounded-full border border-grey-200  hover:border-blue-400 duration-300", !query.type && !query.voteScore && !query.haveMedia ? "bg-blue-500 border-transparent text-white" : "bg-white ", loading ? "cursor-not-allowed" : "cursor-pointer"),
                        children: [
                            "Tất cả (",
                            ((_numberNewReview_totalReview1 = numberNewReview.totalReview) !== null && _numberNewReview_totalReview1 !== void 0 ? _numberNewReview_totalReview1 : 0) + ((_numberNewReview_totalQuestion1 = numberNewReview.totalQuestion) !== null && _numberNewReview_totalQuestion1 !== void 0 ? _numberNewReview_totalQuestion1 : 0),
                            ")"
                        ]
                    }),
                    FILTER_REVIEWS.map((filter)=>{
                        const isActive = router.query[filter.key] === filter.value || !Object.keys(router.query).length && !filter.key && !filter.value;
                        var _numberNewReview_filter_resultKey;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: ()=>{
                                if (!loading) handleFilter(filter.key, filter.value);
                            },
                            className: (0,clsx_m/* default */.Z)("text-grey-600 px-3 py-1 rounded-full border border-grey-200  hover:border-blue-400 duration-300", isActive ? "bg-blue-500 border-transparent text-white" : "bg-white ", loading ? "cursor-not-allowed" : "cursor-pointer"),
                            children: [
                                filter.label,
                                " ",
                                "(".concat((_numberNewReview_filter_resultKey = numberNewReview[filter.resultKey]) !== null && _numberNewReview_filter_resultKey !== void 0 ? _numberNewReview_filter_resultKey : 0, ")")
                            ]
                        }, "".concat(filter.key, "=").concat(filter.value));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetail_InputSearchReview, {
                className: "mb-4"
            })
        ]
    }) : null;
};
/* harmony default export */ var ProjectDetail_ReviewFilter = (ReviewFilter);

// EXTERNAL MODULE: ./src/components/Modal/index.tsx
var Modal = __webpack_require__(52591);
// EXTERNAL MODULE: ./node_modules/antd/es/progress/index.js + 13 modules
var progress = __webpack_require__(38703);
// EXTERNAL MODULE: ./src/components/VideoPlayer.tsx
var VideoPlayer = __webpack_require__(19534);
// EXTERNAL MODULE: ./src/constants/enum/media.ts
var media = __webpack_require__(71381);
// EXTERNAL MODULE: ./src/api/endpoint/reviews/get-list-file-review-project.ts
var get_list_file_review_project = __webpack_require__(66353);
// EXTERNAL MODULE: ./src/constants/number.ts
var number = __webpack_require__(20691);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./src/modules/Desktop/ProjectDetail/RightContent/ModalViewDetailFile.tsx
var ModalViewDetailFile = __webpack_require__(25256);
;// CONCATENATED MODULE: ./src/modules/Desktop/ProjectDetail/RightContent/ModalViewAllFile.tsx















const ModalViewAllFile = (param)=>{
    let { openModal , setOpenModalAllFile , openModalDetail , setOpenModalDetail  } = param;
    var _selectedViewFiles_files, _selectedViewFiles_files1, _selectedViewFiles_files2, _selectedViewFiles_files3;
    const { selectedViewFiles , setSelectedViewFiles , projectListFile , setProjectListFile , project  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const [activeTab, setActiveTab] = (0,react.useState)(null);
    const FILE_TAB = [
        {
            label: "Tất cả",
            key: null,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        },
        {
            label: "Ảnh",
            key: media/* MediaTypeEnum.IMAGE */.L.IMAGE,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        },
        {
            label: "Video",
            key: media/* MediaTypeEnum.VIDEO */.L.VIDEO,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        },
        {
            label: "T\xe0i liệu",
            key: media/* MediaTypeEnum.FILE */.L.FILE,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        },
        {
            label: "Link",
            key: media/* MediaTypeEnum.LINK */.L.LINK,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        }
    ];
    const onLoadMore = async ()=>{
        const res = await (0,get_list_file_review_project/* getListFileReviewProject */.c)(project === null || project === void 0 ? void 0 : project._id, {
            type: activeTab ? activeTab : "".concat(media/* MediaTypeEnum.IMAGE */.L.IMAGE, ",").concat(media/* MediaTypeEnum.VIDEO */.L.VIDEO, ",").concat(media/* MediaTypeEnum.FILE */.L.FILE),
            page: (projectListFile === null || projectListFile === void 0 ? void 0 : projectListFile.page) + 1,
            limit: number/* PAGE_SIZE_FILE */.Ew
        });
        if (res) {
            setProjectListFile({
                ...res,
                results: [
                    ...projectListFile.results,
                    ...res.results
                ]
            });
            setSelectedViewFiles({
                currentFile: null,
                files: [
                    ...projectListFile.results,
                    ...res.results
                ]
            });
        }
    };
    const handleChangeTabFile = async (type)=>{
        setSelectedViewFiles({
            currentFile: null,
            files: []
        });
        const res = await (0,get_list_file_review_project/* getListFileReviewProject */.c)(project === null || project === void 0 ? void 0 : project._id, {
            type: type ? "".concat(type) : "".concat(media/* MediaTypeEnum.IMAGE */.L.IMAGE, ",").concat(media/* MediaTypeEnum.VIDEO */.L.VIDEO, ",").concat(media/* MediaTypeEnum.FILE */.L.FILE),
            page: 1,
            limit: number/* PAGE_SIZE_FILE */.Ew
        });
        if (res) {
            setProjectListFile({
                ...res,
                results: [
                    ...res.results
                ]
            });
            setSelectedViewFiles({
                currentFile: null,
                files: [
                    ...res.results
                ]
            });
            const listFileElement = document.getElementById("scrollableDiv");
            if (listFileElement) listFileElement.scrollTo(0, 0);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: openModal,
                onClose: ()=>{
                    if (activeTab) {
                        handleChangeTabFile(null);
                    }
                    setOpenModalAllFile(false);
                },
                headerClassName: "!bg-white border-b border-solid border-grey-100",
                bodyClassName: "w-[66.75rem] h-[80vh] flex flex-col gap-4",
                footerClassName: "border-none",
                header: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2 text-blue-600",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "mrv mrv-apps text-fs-24"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-semibold text-fs-20",
                            children: "Tất cả File"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "home-tabs",
                            children: FILE_TAB.map((tab)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("home-tab", activeTab === tab.key ? "home-tab-active" : ""),
                                    onClick: ()=>{
                                        if ((tab === null || tab === void 0 ? void 0 : tab.key) == media/* MediaTypeEnum.LINK */.L.LINK) {
                                            setSelectedViewFiles({
                                                currentFile: null,
                                                files: []
                                            });
                                        }
                                        setActiveTab(tab === null || tab === void 0 ? void 0 : tab.key);
                                        handleChangeTabFile(tab === null || tab === void 0 ? void 0 : tab.key);
                                    },
                                    children: tab.label
                                }, tab === null || tab === void 0 ? void 0 : tab.key);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 h-[calc(80vh-92px)] overflow-y-auto",
                            id: "scrollableDiv",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                dataLength: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files = selectedViewFiles.files) === null || _selectedViewFiles_files === void 0 ? void 0 : _selectedViewFiles_files.length) || 0,
                                next: onLoadMore,
                                hasMore: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files1 = selectedViewFiles.files) === null || _selectedViewFiles_files1 === void 0 ? void 0 : _selectedViewFiles_files1.length) < (projectListFile === null || projectListFile === void 0 ? void 0 : projectListFile.totalResults),
                                loader: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-4 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "dot-flashing"
                                    })
                                }),
                                scrollableTarget: "scrollableDiv",
                                children: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files2 = selectedViewFiles.files) === null || _selectedViewFiles_files2 === void 0 ? void 0 : _selectedViewFiles_files2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: activeTab == media/* MediaTypeEnum.LINK */.L.LINK ? "flex flex-col gap-4" : "grid grid-cols-6 gap-3 h-full",
                                    children: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files3 = selectedViewFiles.files) === null || _selectedViewFiles_files3 === void 0 ? void 0 : _selectedViewFiles_files3.map((file, id)=>{
                                        if (file === null || file === void 0 ? void 0 : file.url) {
                                            var _file_name_split, _file_name, _file_favicon;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: ()=>{
                                                    if ((file === null || file === void 0 ? void 0 : file.mediaType) != media/* MediaTypeEnum.LINK.toString */.L.LINK.toString()) {
                                                        setSelectedViewFiles({
                                                            currentFile: file,
                                                            files: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
                                                        });
                                                        setOpenModalDetail(true);
                                                    }
                                                },
                                                className: (0,clsx_m/* default */.Z)("relative group cursor-pointer ", file.mediaType == media/* MediaTypeEnum.IMAGE.toString */.L.IMAGE.toString() || file.mediaType == media/* MediaTypeEnum.VIDEO.toString */.L.VIDEO.toString() ? "can-preview-upload" : "default-file"),
                                                children: [
                                                    file.mediaType == media/* MediaTypeEnum.IMAGE.toString */.L.IMAGE.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-[10rem] h-[10rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: " text-fs-12 w-full h-full overflow-hidden rounded",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                                                className: "object-cover w-full h-full",
                                                                src: file.uri,
                                                                alt: file.name,
                                                                resizeOnFly: !!(file === null || file === void 0 ? void 0 : file.uri),
                                                                resizeOptions: {
                                                                    width: 160,
                                                                    height: 160
                                                                }
                                                            })
                                                        })
                                                    }) : file.mediaType == media/* MediaTypeEnum.VIDEO.toString */.L.VIDEO.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-[10rem] h-[10rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: " text-fs-12 w-full h-full overflow-hidden rounded-md",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer/* default */.Z, {
                                                                    options: {
                                                                        autoplay: false,
                                                                        controls: false,
                                                                        responsive: true,
                                                                        fluid: true,
                                                                        preload: "metadata",
                                                                        sources: [
                                                                            {
                                                                                src: file.urlVod
                                                                            }
                                                                        ]
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "mrv mrv-play_arrow text-white text-fs-28 font-bold"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }) : file.mediaType == media/* MediaTypeEnum.FILE.toString */.L.FILE.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-[10rem] h-[10rem] bg-grey-200 rounded-md flex flex-col gap-[66px] relative cursor-pointer border border-transparent border-dashed",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex-[0_0_24px] w-full flex items-end pt-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "mrv mrv-attach_file text-fs-24 leading-6"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "text-fs-12",
                                                                        children: [
                                                                            ".",
                                                                            (_file_name_split = file === null || file === void 0 ? void 0 : (_file_name = file.name) === null || _file_name === void 0 ? void 0 : _file_name.split(".")) === null || _file_name_split === void 0 ? void 0 : _file_name_split.pop()
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "bg-grey-300 flex-[1_1_auto] text-fs-12 py-1.5 px-2 overflow-hidden rounded-b-md break-all",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "line-clamp-2",
                                                                    children: file.name
                                                                })
                                                            })
                                                        ]
                                                    }) : (file === null || file === void 0 ? void 0 : file.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: file === null || file === void 0 ? void 0 : file.url,
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex gap-2 items-center w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "h-8 w-8 p-1 flex items-center justify-center",
                                                                    children: (file === null || file === void 0 ? void 0 : (_file_favicon = file.favicon) === null || _file_favicon === void 0 ? void 0 : _file_favicon.match(common_constant/* urlRegex */.yV)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: file === null || file === void 0 ? void 0 : file.favicon,
                                                                        alt: (file === null || file === void 0 ? void 0 : file.name) || ""
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "mrv mrv-link text-fs-24 text-black-1000"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-col flex-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "text-black-1000 text-fs-14 font-medium line-clamp-1 break-word",
                                                                            title: file === null || file === void 0 ? void 0 : file.name,
                                                                            children: file === null || file === void 0 ? void 0 : file.name
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "text-blue-600 text-fs-12 line-clamp-1 break-word",
                                                                            title: file === null || file === void 0 ? void 0 : file.url,
                                                                            children: file === null || file === void 0 ? void 0 : file.url
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "text-fs-12 text-grey-500",
                                                                    children: dayjs_min_default()(file === null || file === void 0 ? void 0 : file.createdAt).format("DD/MM/YYYY")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "mrv mrv-more_horiz text-fs-18 text-grey-600"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }) : null,
                                                    activeTab !== media/* MediaTypeEnum.LINK */.L.LINK ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cursor-pointer absolute w-full h-full top-0 z-10 bg-[rgba(0,0,0,0.4)] flex items-center justify-center opacity-0 group-hover:opacity-100 rounded-md duration-300",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "mrv mrv-preview text-white text-fs-28"
                                                        })
                                                    }) : null
                                                ]
                                            }, file._id);
                                        }
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-grey-500 text-fs-24 font-semibold w-full text-center",
                                    children: "Chưa c\xf3 dữ liệu"
                                })
                            })
                        }, activeTab)
                    ]
                })
            }),
            (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile) && openModalDetail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalViewDetailFile/* default */.Z, {}) : null
        ]
    });
};
/* harmony default export */ var RightContent_ModalViewAllFile = (ModalViewAllFile);

;// CONCATENATED MODULE: ./src/modules/Desktop/ProjectDetail/RightContent/FileMedia.tsx










const MAX_FILE_SHOW = 4;
const FileMedia = (param)=>{
    let { enableShowFull =true , maxFileShow =MAX_FILE_SHOW  } = param;
    var _topFileMedia_slice;
    const { projectListFile , selectedViewFiles , setSelectedViewFiles , topFileMedia  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const [openModalAllFile, setOpenModalAllFile] = (0,react.useState)(false);
    const [openModalDetailFile, setOpenModalDetailFile] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile) && !openModalAllFile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalViewDetailFile/* default */.Z, {}) : null,
            openModalAllFile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContent_ModalViewAllFile, {
                openModal: openModalAllFile,
                setOpenModalAllFile: setOpenModalAllFile,
                openModalDetail: openModalDetailFile,
                setOpenModalDetail: setOpenModalDetailFile
            }) : null,
            (topFileMedia === null || topFileMedia === void 0 ? void 0 : topFileMedia.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white rounded-lg p-3 shadow-light-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-grey-500 text-fs-14 font-medium",
                        children: "FILE PHƯƠNG TIỆN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "my-3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-2 gap-3",
                        children: (_topFileMedia_slice = topFileMedia === null || topFileMedia === void 0 ? void 0 : topFileMedia.slice(0, maxFileShow)) === null || _topFileMedia_slice === void 0 ? void 0 : _topFileMedia_slice.map((file)=>{
                            var _file_name_split, _file_name;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: ()=>{
                                    if (enableShowFull) {
                                        setSelectedViewFiles({
                                            currentFile: file,
                                            files: projectListFile === null || projectListFile === void 0 ? void 0 : projectListFile.results
                                        });
                                        setOpenModalDetailFile(true);
                                    }
                                },
                                className: (0,clsx_m/* default */.Z)("relative group cursor-pointer", file.mediaType == media/* MediaTypeEnum.IMAGE.toString */.L.IMAGE.toString() || file.mediaType == media/* MediaTypeEnum.VIDEO.toString */.L.VIDEO.toString() ? "can-preview-upload" : "default-file"),
                                children: [
                                    file.mediaType == media/* MediaTypeEnum.IMAGE.toString */.L.IMAGE.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[138px] h-[138px] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " text-fs-12 w-full h-full overflow-hidden rounded",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                                className: "object-cover w-full h-full",
                                                src: file.uri,
                                                alt: file.name,
                                                resizeOnFly: !!(file === null || file === void 0 ? void 0 : file.uri),
                                                resizeOptions: {
                                                    width: 138,
                                                    height: 138
                                                }
                                            })
                                        })
                                    }) : file.mediaType == media/* MediaTypeEnum.VIDEO.toString */.L.VIDEO.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[138px] h-[138px] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-fs-12 w-full h-full overflow-hidden rounded-md",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer/* default */.Z, {
                                                    options: {
                                                        autoplay: false,
                                                        controls: false,
                                                        responsive: true,
                                                        fluid: true,
                                                        preload: "metadata",
                                                        sources: [
                                                            {
                                                                src: file.urlVod
                                                            }
                                                        ]
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "mrv mrv-play_arrow text-white text-fs-28 font-bold"
                                                    })
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[138px] h-[138px] bg-grey-200 rounded-md flex flex-col gap-[66px] relative cursor-pointer border border-transparent border-dashed",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex-[0_0_24px] w-full flex items-end pt-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "mrv mrv-attach_file text-fs-24 leading-6"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-fs-12",
                                                        children: [
                                                            ".",
                                                            (_file_name_split = file === null || file === void 0 ? void 0 : (_file_name = file.name) === null || _file_name === void 0 ? void 0 : _file_name.split(".")) === null || _file_name_split === void 0 ? void 0 : _file_name_split.pop()
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bg-grey-300 flex-[1_1_auto] text-fs-12 py-1.5 px-2 overflow-hidden rounded-b-md break-all",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "line-clamp-2",
                                                    children: file.name
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cursor-pointer absolute w-full h-full top-0 z-10 bg-[rgba(0,0,0,0.4)] flex items-center justify-center opacity-0 group-hover:opacity-100 rounded-md duration-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mrv mrv-preview text-white text-fs-28"
                                        })
                                    })
                                ]
                            }, file._id);
                        })
                    }),
                    (topFileMedia === null || topFileMedia === void 0 ? void 0 : topFileMedia.length) > 4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "meey-button meey-button-grey meey-button-filled rounded-md text-fs-16 font-semibold py-2.5 px-4 h-11 flex justify-center items-center w-full mt-3",
                        onClick: ()=>{
                            setOpenModalAllFile(true);
                            setSelectedViewFiles({
                                currentFile: null,
                                files: projectListFile === null || projectListFile === void 0 ? void 0 : projectListFile.results
                            });
                        },
                        children: "Xem th\xeam"
                    }) : null
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
};
/* harmony default export */ var RightContent_FileMedia = (FileMedia);

// EXTERNAL MODULE: ./src/utils/number.ts + 1 modules
var utils_number = __webpack_require__(1495);
;// CONCATENATED MODULE: ./src/modules/Desktop/ProjectDetail/RightContent/ProjectVideoBox/index.tsx









const ProjectVideoBox = ()=>{
    const [currentVideo, setCurrrentVideo] = (0,react.useState)(null);
    const { projectVideos , project  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const bigVideoCard = (0,react.useMemo)(()=>{
        return projectVideos.length >= 3 || projectVideos.length == 1 ? projectVideos[0] : null;
    }, [
        projectVideos
    ]);
    const smallVideoCard = (0,react.useMemo)(()=>{
        return projectVideos.length >= 3 ? projectVideos.slice(1, 3) : projectVideos.length == 2 ? projectVideos.slice(0, 2) : [];
    }, [
        projectVideos
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white rounded-lg p-3 shadow-light-1 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-grey-500 text-fs-14 font-medium",
                        children: "TH\xd4NG TIN DỰ \xc1N"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "my-2"
                    }),
                    bigVideoCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative cursor-pointer mb-3",
                        onClick: ()=>setCurrrentVideo(bigVideoCard),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                src: bigVideoCard === null || bigVideoCard === void 0 ? void 0 : bigVideoCard.avatar.uri,
                                className: "rounded-md"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute w-9 h-9 bg-[rgba(0,0,0,0.4)] rounded-full flex items-center justify-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-play_arrow text-white text-fs-28"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute bottom-2 left-3 text-white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-semibold line-clamp-1",
                                        children: bigVideoCard === null || bigVideoCard === void 0 ? void 0 : bigVideoCard.title
                                    }),
                                    bigVideoCard.totalView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-fs-12 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "mrv mrv-visibility mr-1 text-base"
                                            }),
                                            " ",
                                            (0,utils_number/* formatNumber */.uf)(bigVideoCard.totalView) + " lượt xem"
                                        ]
                                    }) : ""
                                ]
                            })
                        ]
                    }) : null,
                    (smallVideoCard === null || smallVideoCard === void 0 ? void 0 : smallVideoCard.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-3 w-full mb-3",
                        children: smallVideoCard.map((card)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: "relative w-[140px] cursor-pointer",
                                onClick: ()=>setCurrrentVideo(card),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                        src: card === null || card === void 0 ? void 0 : card.avatar.uri,
                                        resizeOptions: {
                                            width: 140,
                                            height: 246
                                        },
                                        className: "rounded-md object-cover w-full h-full"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-9 h-9 bg-[rgba(0,0,0,0.4)] rounded-full flex items-center justify-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mrv mrv-play_arrow text-white text-fs-28"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "absolute bottom-2 left-3 right-3 text-white",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-semibold line-clamp-2",
                                                children: card.title
                                            }),
                                            card.totalView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-fs-12 flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "mrv mrv-visibility mr-1 text-base"
                                                    }),
                                                    " ",
                                                    (0,utils_number/* formatNumber */.uf)(card.totalView) + " lượt xem"
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            }, card._id);
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        className: "font-medium",
                        target: "_blank",
                        href: environment/* APP_MEEYPROJECT_URL */.TY + "/project/" + project.slug + "-" + project.shortId,
                        children: "Xem th\xeam video đ\xe1nh gi\xe1"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: !!currentVideo,
                onClose: ()=>setCurrrentVideo(null),
                footerClassName: "border-none !p-0",
                contentClassName: "w-[80vw] ",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "line-clamp-1",
                    children: currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title
                }),
                bodyClassName: "h-[80vh] w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer/* default */.Z, {
                    options: {
                        autoplay: "muted",
                        muted: true,
                        controls: true,
                        responsive: true,
                        preload: "metadata",
                        fluid: true,
                        sources: [
                            {
                                src: currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.url
                            }
                        ]
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var RightContent_ProjectVideoBox = (ProjectVideoBox);

;// CONCATENATED MODULE: ./src/modules/Desktop/ProjectDetail/RightContent/RightContent.tsx












const RightContent = (param)=>{
    let { project  } = param;
    var _project_votes;
    const [openModalInfo, setOpenModalInfo] = (0,react.useState)(false);
    const [mounted, setMounted] = (0,react.useState)(false);
    const [isShowMore, setIsShowMore] = (0,react.useState)(false);
    const { projectVideos  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    (0,react.useEffect)(()=>{
        setMounted(true);
    }, []);
    (0,react.useEffect)(()=>{
        if (mounted) {
            const projectDes = document.getElementById("project-description");
            setIsShowMore((projectDes === null || projectDes === void 0 ? void 0 : projectDes.offsetHeight) > 275);
        }
    }, [
        mounted,
        project
    ]);
    const isShowVoteScore = (0,react.useMemo)(()=>{
        var _project_votes;
        const isHasScore = project === null || project === void 0 ? void 0 : (_project_votes = project.votes) === null || _project_votes === void 0 ? void 0 : _project_votes.find((vote)=>vote.score > 0);
        if (isHasScore) {
            return true;
        }
        return false;
    }, [
        project === null || project === void 0 ? void 0 : project.votes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-6 flex-[0_0_19.5rem]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    (projectVideos === null || projectVideos === void 0 ? void 0 : projectVideos.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContent_ProjectVideoBox, {}) : (project === null || project === void 0 ? void 0 : project.description) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white rounded-lg p-3 shadow-light-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-grey-500 text-fs-14 font-medium",
                                children: "VỀ DỰ \xc1N"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "my-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-fs-14 text-grey-700 overflow-hidden",
                                id: "project-description",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)("text-ellipsis break-words whitespace-pre-line", isShowMore ? "max-h-[260px] overflow-hidden" : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: project === null || project === void 0 ? void 0 : project.description
                                        }
                                    }),
                                    isShowMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "... "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: environment/* APP_MEEYPROJECT_URL */.TY + "/project/" + project.slug + "-" + project.shortId,
                                                target: "_blank",
                                                className: "text-blue-500 cursor-pointer",
                                                children: "xem th\xeam"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        ]
                    }) : null,
                    isShowVoteScore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white rounded-lg p-3 shadow-light-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-grey-500 text-fs-14 font-medium",
                                children: "TI\xcaU CH\xcd Đ\xc1NH GI\xc1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "my-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-3",
                                children: (project === null || project === void 0 ? void 0 : project.votes) && (project === null || project === void 0 ? void 0 : (_project_votes = project.votes) === null || _project_votes === void 0 ? void 0 : _project_votes.length) ? project === null || project === void 0 ? void 0 : project.votes.map((vote)=>{
                                    var _RATE_CATEGORY_find, _vote_score;
                                    const label = (_RATE_CATEGORY_find = project_constant/* RATE_CATEGORY.find */.K2.find((rate)=>rate.key == vote.voteCategory)) === null || _RATE_CATEGORY_find === void 0 ? void 0 : _RATE_CATEGORY_find.title;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-3 justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-grey-700 font-medium text-fs-14 w-[80px] shrink-0",
                                                children: label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(progress/* default */.Z, {
                                                percent: (vote === null || vote === void 0 ? void 0 : vote.score) * 2 * 10,
                                                showInfo: false,
                                                strokeColor: {
                                                    "0%": (0,utils/* voteCategoryColor */.U)(vote === null || vote === void 0 ? void 0 : vote.score),
                                                    "100%": (0,utils/* voteCategoryColor */.U)(vote === null || vote === void 0 ? void 0 : vote.score)
                                                },
                                                className: "mb-0 mr-0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-grey-700 text-fs-14 font-medium whitespace-nowrap",
                                                children: [
                                                    Number.isInteger(vote === null || vote === void 0 ? void 0 : vote.score) ? vote === null || vote === void 0 ? void 0 : vote.score : vote === null || vote === void 0 ? void 0 : (_vote_score = vote.score) === null || _vote_score === void 0 ? void 0 : _vote_score.toFixed(1),
                                                    "/5"
                                                ]
                                            })
                                        ]
                                    }, vote.voteCategory);
                                }) : null
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContent_FileMedia, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: openModalInfo,
                onClose: ()=>setOpenModalInfo(false),
                footerClassName: "border-none !p-0",
                contentClassName: "w-[40rem]",
                bodyClassName: "!pt-3 !px-6 !pb-6",
                header: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2 text-blue-500",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "mrv mrv-info text-fs-24"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-fs-20 font-semibold",
                            children: "Về dự \xe1n"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-h-[250px] overflow-y-auto text-fs-14 text-grey-700 whitespace-pre-line",
                    children: project === null || project === void 0 ? void 0 : project.description
                })
            })
        ]
    });
};
/* harmony default export */ var RightContent_RightContent = (RightContent);

;// CONCATENATED MODULE: ./src/modules/Desktop/ProjectDetail/index.tsx












const ListReview = dynamic_default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5762)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5762)
            ]
    },
    ssr: false
});
const ProjectDetail = ()=>{
    const { project , checkFollowProject: dataFollowProject , setCheckFollowProject  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const { token  } = (0,useAuth/* useAuth */.a)();
    const [isShowScrolHeader, setIsShowScrollHeader] = (0,react.useState)(false);
    const handleScroll = ()=>{
        const position = window.scrollY;
        setIsShowScrollHeader(position > 468);
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const handleCheckFollowProject = (0,react.useCallback)(async ()=>{
        const res = await checkFollowProject({
            project: project === null || project === void 0 ? void 0 : project._id
        }, token);
        if (res === null || res === void 0 ? void 0 : res.results) {
            setCheckFollowProject(true);
        } else {
            setCheckFollowProject(false);
        }
    }, [
        project === null || project === void 0 ? void 0 : project._id,
        setCheckFollowProject,
        token
    ]);
    (0,react.useEffect)(()=>{
        if (token) {
            handleCheckFollowProject();
        }
    }, [
        handleCheckFollowProject,
        token
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "wrap-home bg-grey-50 min-h-screen",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDetail/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("home-tabs ", isShowScrolHeader ? "fixed w-full top-14 z-20 h-fit" : "layout h-[459px]"),
                children: isShowScrolHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetail_HeaderProjectScroll, {
                    project: project,
                    isFollowProject: dataFollowProject
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetail_HeaderProjectInfo, {
                    project: project,
                    isFollowProject: dataFollowProject
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("layout pb-6 ", isShowScrolHeader ? "!pt-[37rem]" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-6 pt-10 w-full overflow-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListReview, {
                            reviewFilter: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetail_ReviewFilter, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContent_RightContent, {
                            project: project
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Desktop_ProjectDetail = (ProjectDetail);

// EXTERNAL MODULE: ./src/extensions/route.ts
var route = __webpack_require__(89155);
// EXTERNAL MODULE: ./src/modules/Mobile/ProjectDetailMobile/HeaderDetail.tsx
var ProjectDetailMobile_HeaderDetail = __webpack_require__(20179);
;// CONCATENATED MODULE: ./src/modules/Mobile/ProjectDetailMobile/HeaderProjectInfo.tsx

















const HeaderProjectInfo_ModalAddReviewProjectDetail = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(8762), __webpack_require__.e(2678), __webpack_require__.e(2540), __webpack_require__.e(6140), __webpack_require__.e(6509)]).then(__webpack_require__.bind(__webpack_require__, 36509)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(36509)
            ]
    },
    ssr: false
});
const HeaderProjectInfo_HeaderProjectInfo = (param)=>{
    let { project , isFollowProject  } = param;
    var _project_banner, _project_banner1, _project_logo, _project_logo1, _project_voteScore, _project_voteScore1;
    const { setCheckFollowProject  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const { token , login  } = (0,useAuth/* useAuth */.a)();
    const [openModalReview, setOpenModalReview] = (0,react.useState)(false);
    const [reviewType, setReviewType] = (0,react.useState)(comment/* CommentTypeEnum.REVIEW */.I.REVIEW);
    const { asPath  } = (0,next_router.useRouter)();
    const handleFollowProject = async ()=>{
        if (!token) {
            login();
        } else {
            const res = await createFollowProject({
                project: project === null || project === void 0 ? void 0 : project._id,
                status: isFollowProject ? common_constant/* FOLLOW_PROJECT_STATUS.UN_FOLLOW */.l8.UN_FOLLOW : common_constant/* FOLLOW_PROJECT_STATUS.FOLLOW */.l8.FOLLOW
            }, token);
            if (res) {
                setCheckFollowProject(!isFollowProject);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full h-fit bg-white shadow-light-1 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                src: (project === null || project === void 0 ? void 0 : (_project_banner = project.banner) === null || _project_banner === void 0 ? void 0 : _project_banner.uri) || environment/* STATIC_DOMAIN */.xm + "/images/default_banner_project.png",
                resizeOnFly: !!(project === null || project === void 0 ? void 0 : (_project_banner1 = project.banner) === null || _project_banner1 === void 0 ? void 0 : _project_banner1.uri),
                resizeOptions: {
                    width: 0,
                    height: 274
                },
                alt: "banner" + project.title,
                className: "object-cover h-[150px] w-full"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " items-center justify-between gap-6 px-4 mt-[-68px] mb-2 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-end gap-3 mb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                            src: (project === null || project === void 0 ? void 0 : project.logo) ? project === null || project === void 0 ? void 0 : (_project_logo = project.logo) === null || _project_logo === void 0 ? void 0 : _project_logo.uri : "".concat(environment/* STATIC_DOMAIN */.xm, "/").concat(project_constant/* DEFAULT_LOGO_PROJECT */.J3),
                            alt: project === null || project === void 0 ? void 0 : project.title,
                            resizeOnFly: !!(project === null || project === void 0 ? void 0 : (_project_logo1 = project.logo) === null || _project_logo1 === void 0 ? void 0 : _project_logo1.uri),
                            resizeOptions: {
                                width: 0,
                                height: 88
                            },
                            className: "rounded-full border-2 h-[5.5rem] w-[5.5rem] border-solid border-grey-50 object-contain bg-white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-fs-18 font-semibold text-grey-700 line-clamp-1 mb-2",
                                children: project === null || project === void 0 ? void 0 : project.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-fs-12 text-grey-500",
                                children: (0,utils/* convertAddressNoStreet */.NL)(project) || "----"
                            })
                        ]
                    }),
                    (project === null || project === void 0 ? void 0 : project.totalHotReview) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " flex items-center gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-fs-20 font-semibold text-grey-700",
                                children: (project === null || project === void 0 ? void 0 : project.voteScore) ? Number.isInteger(project === null || project === void 0 ? void 0 : project.voteScore) ? project === null || project === void 0 ? void 0 : project.voteScore : project === null || project === void 0 ? void 0 : (_project_voteScore = project.voteScore) === null || _project_voteScore === void 0 ? void 0 : _project_voteScore.toFixed(1) : null
                            }),
                            (project === null || project === void 0 ? void 0 : project.voteScore) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyRate/* default */.Z, {
                                disable: true,
                                value: Number.isInteger(project === null || project === void 0 ? void 0 : project.voteScore) ? project === null || project === void 0 ? void 0 : project.voteScore : Number(project === null || project === void 0 ? void 0 : (_project_voteScore1 = project.voteScore) === null || _project_voteScore1 === void 0 ? void 0 : _project_voteScore1.toFixed(1)),
                                itemClassName: "!text-fs-20",
                                className: "h-4 items-center"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-fs-12 text-grey-400 font-medium",
                                children: [
                                    "(",
                                    project === null || project === void 0 ? void 0 : project.totalHotReview,
                                    " reviews)"
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2 px-4 pb-3 border-b border-solid border-grey-100 mb-1 flex-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "primary",
                                btnType: "filled",
                                className: "flex-[1_1_auto] justify-center h-9",
                                onClick: ()=>{
                                    setOpenModalReview(true);
                                    setReviewType(comment/* CommentTypeEnum.REVIEW */.I.REVIEW);
                                },
                                prefixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-review text-fs-18",
                                    children: " "
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-fs-14 font-semibold",
                                    children: "Viết review"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "meey-button meey-button-filled !bg-purple-500 hover:!text-white py-2.5 px-4 h-9 flex items-center gap-1 !border-none flex-[1_1_auto] justify-center",
                                onClick: ()=>{
                                    setOpenModalReview(true);
                                    setReviewType(comment/* CommentTypeEnum.QUESTION */.I.QUESTION);
                                },
                                prefixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-contact_support text-fs-18"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-fs-14 font-semibold",
                                    children: "Đặt c\xe2u hỏi"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "meey-button meey-button-grey meey-button-filled py-2.5 px-4 h-9 flex items-center justify-center gap-1 flex-[1_1_auto]",
                                onClick: handleFollowProject,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-hearing text-fs-18"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-fs-14 font-semibold",
                                        children: isFollowProject ? "Đ\xe3 h\xf3ng" : "H\xf3ng"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* default */.Z, {
                                shareUrl: (0,url_join/* default */.Z)(environment/* APP_BASE_URL */.E5, asPath),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "meey-button meey-button-grey meey-button-filled h-9 w-9 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-share text-fs-18"
                                    })
                                })
                            })
                        ]
                    }),
                    openModalReview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderProjectInfo_ModalAddReviewProjectDetail, {
                        open: openModalReview,
                        handleClose: ()=>setOpenModalReview(false),
                        project: project,
                        reviewType: reviewType
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var ProjectDetailMobile_HeaderProjectInfo = (HeaderProjectInfo_HeaderProjectInfo);

// EXTERNAL MODULE: ./src/modules/common/ProjectDetail/ListReview.tsx + 3 modules
var ProjectDetail_ListReview = __webpack_require__(5762);
;// CONCATENATED MODULE: ./src/modules/Mobile/ProjectDetailMobile/ReviewFilter.tsx
// import HeaderHome from "./HeaderHome";









// import Newest from "./Newest";
const ReviewFilter_ReviewFilter = ()=>{
    const router = (0,next_router.useRouter)();
    const handleFilter = (key, value)=>{
        router.push({
            query: (0,utils/* skipNullParams */.Jm)({
                id: router.query.id,
                [key]: value,
                comment: router.query.comment
            })
        });
    };
    const [showFilter, setShowFilter] = (0,react.useState)(false);
    const { numberNewReview  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const { loading  } = (0,useChangeRoute/* useChangeRoute */.r)();
    const activeFilter = FILTER_REVIEWS.find((filter)=>router.query[filter.key] === filter.value || !Object.keys(router.query).length && !filter.key && !filter.value);
    var _numberNewReview_totalReview, _numberNewReview_totalQuestion, _numberNewReview_totalReview1, _numberNewReview_totalQuestion1;
    return ((_numberNewReview_totalReview = numberNewReview.totalReview) !== null && _numberNewReview_totalReview !== void 0 ? _numberNewReview_totalReview : 0) + ((_numberNewReview_totalQuestion = numberNewReview.totalQuestion) !== null && _numberNewReview_totalQuestion !== void 0 ? _numberNewReview_totalQuestion : 0) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white p-4 border-b border-b-grey-200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetail_InputSearchReview, {
                className: "mb-4"
            }),
            (numberNewReview === null || numberNewReview === void 0 ? void 0 : numberNewReview.today) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-grey-600 text-base font-medium mb-2",
                children: [
                    "C\xf3 ",
                    numberNewReview === null || numberNewReview === void 0 ? void 0 : numberNewReview.today,
                    " review mới h\xf4m nay",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-red-600",
                        children: "•"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("text-grey-700 flex gap-1 items-center cursor-pointer duration-300 mt-4", showFilter ? "mb-3" : ""),
                onClick: ()=>setShowFilter(!showFilter),
                children: [
                    "Lọc:",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-semibold flex items-center",
                        children: [
                            " ",
                            activeFilter ? activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.label : "Tất cả",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "mrv mrv-arrow_drop_down !text-base"
                            })
                        ]
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex flex-wrap  gap-2 duration-300 overflow-hidden  ", showFilter ? " max-h-[240px]" : " max-h-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: ()=>{
                            if (!loading) router.push({
                                query: (0,utils/* skipNullParams */.Jm)({
                                    id: router.query.id,
                                    comment: router.query.comment
                                })
                            });
                        },
                        className: (0,clsx_m/* default */.Z)("text-fs-12 text-grey-600 px-3 py-1 rounded-full border border-grey-200  hover:border-blue-400 duration-300", Object.keys(router.query).length === 1 ? "bg-blue-500 border-transparent text-white" : "bg-white ", loading ? "cursor-not-allowed" : "cursor-pointer"),
                        children: [
                            "Tất cả (",
                            ((_numberNewReview_totalReview1 = numberNewReview.totalReview) !== null && _numberNewReview_totalReview1 !== void 0 ? _numberNewReview_totalReview1 : 0) + ((_numberNewReview_totalQuestion1 = numberNewReview.totalQuestion) !== null && _numberNewReview_totalQuestion1 !== void 0 ? _numberNewReview_totalQuestion1 : 0),
                            ")"
                        ]
                    }),
                    FILTER_REVIEWS.map((filter)=>{
                        const isActive = router.query[filter.key] === filter.value || !Object.keys(router.query).length && !filter.key && !filter.value;
                        var _numberNewReview_filter_resultKey;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: ()=>{
                                if (!loading) handleFilter(filter.key, filter.value);
                            },
                            className: (0,clsx_m/* default */.Z)("text-fs-12 text-grey-600 px-3 py-1 rounded-full border border-grey-200  hover:border-blue-400 duration-300", isActive ? "bg-blue-500 border-transparent text-white" : "bg-white ", loading ? "cursor-not-allowed" : "cursor-pointer"),
                            children: [
                                filter.label,
                                " ",
                                "(".concat((_numberNewReview_filter_resultKey = numberNewReview[filter.resultKey]) !== null && _numberNewReview_filter_resultKey !== void 0 ? _numberNewReview_filter_resultKey : 0, ")")
                            ]
                        }, "".concat(filter.key, "=").concat(filter.value));
                    })
                ]
            })
        ]
    }) : null;
};
/* harmony default export */ var ProjectDetailMobile_ReviewFilter = (ReviewFilter_ReviewFilter);

;// CONCATENATED MODULE: ./src/modules/Mobile/ProjectDetailMobile/RightContent/ProjectVideoBox/index.tsx









const ProjectVideoBox_ProjectVideoBox = ()=>{
    const [currentVideo, setCurrrentVideo] = (0,react.useState)(null);
    const { projectVideos , project  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white rounded-lg py-3w-full",
                children: [
                    (projectVideos === null || projectVideos === void 0 ? void 0 : projectVideos.length) ? projectVideos.slice(0, 3).map((card)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "relative cursor-pointer mb-3",
                            onClick: ()=>setCurrrentVideo(card),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                    src: card === null || card === void 0 ? void 0 : card.avatar.uri,
                                    className: "rounded-md w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute w-9 h-9 bg-[rgba(0,0,0,0.4)] rounded-full flex items-center justify-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-play_arrow text-white text-fs-28"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute bottom-2 left-3 text-white",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-semibold line-clamp-1",
                                            children: card === null || card === void 0 ? void 0 : card.title
                                        }),
                                        card.totalView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-fs-12 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "mrv mrv-visibility mr-1 text-base"
                                                }),
                                                " ",
                                                (0,utils_number/* formatNumber */.uf)(card.totalView) + " lượt xem"
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        }, card._id);
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        className: "font-medium",
                        target: "_blank",
                        href: environment/* APP_MEEYPROJECT_URL */.TY + "/project/" + project.slug + "-" + project.shortId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            btnType: "outline",
                            color: "primary",
                            className: "w-full flex justify-center",
                            children: "Xem th\xeam video đ\xe1nh gi\xe1"
                        })
                    })
                ]
            }),
            currentVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fixed w-screen h-screen bg-black-1000 top-0 left-0 z-[200]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-4 right-4 text-fs-24 z-20",
                        onClick: ()=>setCurrrentVideo(null),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "mrv mrv-close text-white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer/* default */.Z, {
                        options: {
                            autoplay: "muted",
                            muted: true,
                            controls: true,
                            responsive: true,
                            preload: "metadata",
                            preferFullWindow: true,
                            fluid: true,
                            sources: [
                                {
                                    src: currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.url
                                }
                            ]
                        }
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var ProjectDetailMobile_RightContent_ProjectVideoBox = (ProjectVideoBox_ProjectVideoBox);

;// CONCATENATED MODULE: ./src/modules/Mobile/ProjectDetailMobile/RightContent/AboutProject.tsx






const AboutProject = ()=>{
    const { project , projectVideos  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white p-4 h-full text-fs-14",
        children: (projectVideos === null || projectVideos === void 0 ? void 0 : projectVideos.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetailMobile_RightContent_ProjectVideoBox, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: project.description
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: environment/* APP_MEEYPROJECT_URL */.TY + "/project/" + project.slug + "-" + project.shortId,
                    target: "_blank",
                    className: "text-blue-500 cursor-pointer",
                    children: "Xem th\xeam"
                })
            ]
        })
    });
};
/* harmony default export */ var RightContent_AboutProject = (AboutProject);

;// CONCATENATED MODULE: ./src/modules/Mobile/ProjectDetailMobile/RightContent/Evaluation.tsx






const Evaluation = ()=>{
    var _project_votes;
    const { project  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const isShowVoteScore = (0,react.useMemo)(()=>{
        var _project_votes;
        const isHasScore = project === null || project === void 0 ? void 0 : (_project_votes = project.votes) === null || _project_votes === void 0 ? void 0 : _project_votes.find((vote)=>vote.score > 0);
        if (isHasScore) {
            return true;
        }
        return false;
    }, [
        project === null || project === void 0 ? void 0 : project.votes
    ]);
    return isShowVoteScore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-white p-3 m-4 h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-3",
                children: (project === null || project === void 0 ? void 0 : project.votes) && (project === null || project === void 0 ? void 0 : (_project_votes = project.votes) === null || _project_votes === void 0 ? void 0 : _project_votes.length) ? project === null || project === void 0 ? void 0 : project.votes.map((vote)=>{
                    var _RATE_CATEGORY_find, _vote_score;
                    const label = (_RATE_CATEGORY_find = project_constant/* RATE_CATEGORY.find */.K2.find((rate)=>rate.key == vote.voteCategory)) === null || _RATE_CATEGORY_find === void 0 ? void 0 : _RATE_CATEGORY_find.title;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-3 justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-grey-700 font-medium text-fs-14 w-[80px] shrink-0",
                                children: label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(progress/* default */.Z, {
                                percent: (vote === null || vote === void 0 ? void 0 : vote.score) * 2 * 10,
                                showInfo: false,
                                strokeColor: {
                                    "0%": (0,utils/* voteCategoryColor */.U)(vote === null || vote === void 0 ? void 0 : vote.score),
                                    "100%": (0,utils/* voteCategoryColor */.U)(vote === null || vote === void 0 ? void 0 : vote.score)
                                },
                                className: "mb-0 mr-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-grey-700 text-fs-14 font-medium whitespace-nowrap",
                                children: [
                                    Number.isInteger(vote === null || vote === void 0 ? void 0 : vote.score) ? vote === null || vote === void 0 ? void 0 : vote.score : vote === null || vote === void 0 ? void 0 : (_vote_score = vote.score) === null || _vote_score === void 0 ? void 0 : _vote_score.toFixed(1),
                                    "/5"
                                ]
                            })
                        ]
                    }, vote.voteCategory);
                }) : null
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var RightContent_Evaluation = (Evaluation);

;// CONCATENATED MODULE: ./src/modules/Mobile/ProjectDetailMobile/RightContent/FileMedia.tsx













const FileMedia_MAX_FILE_SHOW = 4;
const FileMedia_FileMedia = (param)=>{
    let { enableShowFull =true , maxFileShow =FileMedia_MAX_FILE_SHOW  } = param;
    var _selectedViewFiles_files, _selectedViewFiles_files1, _selectedViewFiles_files2;
    const { selectedViewFiles , setSelectedViewFiles , projectListFile , setProjectListFile , project  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const [activeTab, setActiveTab] = (0,react.useState)(null);
    const FILE_TAB = [
        {
            label: "Tất cả",
            key: null,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        },
        {
            label: "Ảnh",
            key: media/* MediaTypeEnum.IMAGE */.L.IMAGE,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        },
        {
            label: "Video",
            key: media/* MediaTypeEnum.VIDEO */.L.VIDEO,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        },
        {
            label: "T\xe0i liệu",
            key: media/* MediaTypeEnum.FILE */.L.FILE,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        },
        {
            label: "Link",
            key: media/* MediaTypeEnum.LINK */.L.LINK,
            data: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
        }
    ];
    const handleChangeTabFile = async (type)=>{
        const res = await (0,get_list_file_review_project/* getListFileReviewProject */.c)(project === null || project === void 0 ? void 0 : project._id, {
            type: type ? "".concat(type) : "".concat(media/* MediaTypeEnum.IMAGE */.L.IMAGE, ",").concat(media/* MediaTypeEnum.VIDEO */.L.VIDEO, ",").concat(media/* MediaTypeEnum.FILE */.L.FILE),
            page: 1,
            limit: number/* PAGE_SIZE_FILE */.Ew
        });
        if (res) {
            setProjectListFile({
                ...res,
                results: [
                    ...res.results
                ]
            });
            setSelectedViewFiles({
                currentFile: null,
                files: [
                    ...res.results
                ]
            });
            const listFileElement = document.getElementById("scrollableDiv");
            if (listFileElement) listFileElement.scrollTo(0, 0);
        }
    };
    const onLoadMore = async ()=>{
        const res = await (0,get_list_file_review_project/* getListFileReviewProject */.c)(project === null || project === void 0 ? void 0 : project._id, {
            type: activeTab ? activeTab : "".concat(media/* MediaTypeEnum.IMAGE */.L.IMAGE, ",").concat(media/* MediaTypeEnum.VIDEO */.L.VIDEO, ",").concat(media/* MediaTypeEnum.FILE */.L.FILE),
            page: (projectListFile === null || projectListFile === void 0 ? void 0 : projectListFile.page) + 1,
            limit: number/* PAGE_SIZE_FILE */.Ew
        });
        if (res) {
            setProjectListFile({
                ...res,
                results: [
                    ...projectListFile.results,
                    ...res.results
                ]
            });
            setSelectedViewFiles({
                currentFile: null,
                files: [
                    ...projectListFile.results,
                    ...res.results
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white p-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex gap-2",
                children: FILE_TAB.map((tab)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("home-tab cursor-default", activeTab === tab.key ? "home-tab-active" : ""),
                        onClick: ()=>{
                            if ((tab === null || tab === void 0 ? void 0 : tab.key) == media/* MediaTypeEnum.LINK */.L.LINK) {
                                setSelectedViewFiles({
                                    currentFile: null,
                                    files: []
                                });
                            }
                            setActiveTab(tab === null || tab === void 0 ? void 0 : tab.key);
                            handleChangeTabFile(tab === null || tab === void 0 ? void 0 : tab.key);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("mt-1 mb-4 px-2 py-1 text-fs-12 font-medium rounded-[100px]", activeTab === tab.key ? "text-white bg-blue-500" : "text-grey-600 border border-1 border-grey-200 cursor-default md:cursor-pointer bg-grey-50 hover:text-white hover:bg-blue-500"),
                            children: tab.label
                        })
                    }, tab === null || tab === void 0 ? void 0 : tab.key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-h-[40vh] overflow-y-auto",
                id: "scrollableDiv",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                    dataLength: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files = selectedViewFiles.files) === null || _selectedViewFiles_files === void 0 ? void 0 : _selectedViewFiles_files.length) || 0,
                    next: onLoadMore,
                    hasMore: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files1 = selectedViewFiles.files) === null || _selectedViewFiles_files1 === void 0 ? void 0 : _selectedViewFiles_files1.length) < (projectListFile === null || projectListFile === void 0 ? void 0 : projectListFile.totalResults),
                    loader: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-4 flex items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dot-flashing"
                        })
                    }),
                    scrollableTarget: "scrollableDiv",
                    children: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files2 = selectedViewFiles.files) === null || _selectedViewFiles_files2 === void 0 ? void 0 : _selectedViewFiles_files2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: activeTab == media/* MediaTypeEnum.LINK */.L.LINK ? "flex flex-col" : "grid grid-cols-3 justify-between gap-1",
                            children: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files.map((file)=>{
                                var _file_name_split, _file_name, _file_favicon;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    onClick: ()=>{
                                        if ((file === null || file === void 0 ? void 0 : file.mediaType) != media/* MediaTypeEnum.LINK.toString */.L.LINK.toString()) {
                                            setSelectedViewFiles({
                                                currentFile: file,
                                                files: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files
                                            });
                                        }
                                    },
                                    className: (0,clsx_m/* default */.Z)("relative group cursor-pointer", file.mediaType == media/* MediaTypeEnum.IMAGE.toString */.L.IMAGE.toString() || file.mediaType == media/* MediaTypeEnum.VIDEO.toString */.L.VIDEO.toString() ? "can-preview-upload" : "default-file", (file === null || file === void 0 ? void 0 : file.mediaType) == media/* MediaTypeEnum.LINK.toString */.L.LINK.toString() ? "" : "aspect-square"),
                                    children: [
                                        file.mediaType == media/* MediaTypeEnum.IMAGE.toString */.L.IMAGE.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " w-full h-full bg-grey-200 cursor-pointer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                                className: "object-cover w-full h-full ",
                                                src: file.uri,
                                                alt: file.name,
                                                resizeOnFly: !!(file === null || file === void 0 ? void 0 : file.uri),
                                                resizeOptions: {
                                                    width: 243,
                                                    height: 243
                                                }
                                            })
                                        }) : file.mediaType == media/* MediaTypeEnum.VIDEO.toString */.L.VIDEO.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " w-full h-full bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer/* default */.Z, {
                                                    options: {
                                                        autoplay: false,
                                                        controls: false,
                                                        responsive: true,
                                                        fluid: true,
                                                        preload: "metadata",
                                                        sources: [
                                                            {
                                                                src: file.urlVod
                                                            }
                                                        ]
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "mrv mrv-play_arrow text-white text-fs-28 font-bold"
                                                    })
                                                })
                                            ]
                                        }) : file.mediaType == media/* MediaTypeEnum.FILE.toString */.L.FILE.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full h-full bg-grey-200 rounded-md flex flex-col gap-[66px] relative cursor-pointer border border-transparent border-dashed",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex-[0_0_24px] w-full flex items-end pt-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "mrv mrv-attach_file text-fs-24 leading-6"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-fs-12",
                                                            children: [
                                                                ".",
                                                                (_file_name_split = file === null || file === void 0 ? void 0 : (_file_name = file.name) === null || _file_name === void 0 ? void 0 : _file_name.split(".")) === null || _file_name_split === void 0 ? void 0 : _file_name_split.pop()
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "bg-grey-300 flex-[1_1_auto] text-fs-12 py-1.5 px-2 overflow-hidden rounded-b-md break-all",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "line-clamp-2",
                                                        children: file.name
                                                    })
                                                })
                                            ]
                                        }) : (file === null || file === void 0 ? void 0 : file.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: file === null || file === void 0 ? void 0 : file.url,
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-2 items-center w-full py-4 border-b border-solid border-grey-200",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "h-8 w-8 p-1 flex items-center justify-center",
                                                        children: (file === null || file === void 0 ? void 0 : (_file_favicon = file.favicon) === null || _file_favicon === void 0 ? void 0 : _file_favicon.match(common_constant/* urlRegex */.yV)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: file === null || file === void 0 ? void 0 : file.favicon,
                                                            alt: "dcn"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "mrv mrv-link text-fs-24 text-black-1000"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col flex-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-black-1000 text-fs-14 font-medium line-clamp-1 break-word",
                                                                title: file === null || file === void 0 ? void 0 : file.name,
                                                                children: file === null || file === void 0 ? void 0 : file.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex items-center gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-blue-600 text-fs-12 line-clamp-1 break-word",
                                                                        title: file === null || file === void 0 ? void 0 : file.url,
                                                                        children: file === null || file === void 0 ? void 0 : file.url
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-fs-12 text-grey-500 shrink-0",
                                                                        children: dayjs_min_default()(file === null || file === void 0 ? void 0 : file.createdAt).format("DD/MM/YYYY")
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "mrv mrv-more_horiz text-fs-18 text-grey-600"
                                                        })
                                                    })
                                                ]
                                            })
                                        }) : null,
                                        activeTab !== media/* MediaTypeEnum.LINK */.L.LINK ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cursor-pointer absolute w-full h-full top-0 z-10 bg-[rgba(0,0,0,0.4)] flex items-center justify-center opacity-0 group-hover:opacity-100 rounded-md duration-300",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "mrv mrv-preview text-white text-fs-28"
                                            })
                                        }) : null
                                    ]
                                }, file._id);
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-grey-500 text-fs-24 font-semibold w-full text-center",
                        children: "Chưa c\xf3 dữ liệu"
                    })
                })
            }, activeTab)
        ]
    });
};
/* harmony default export */ var ProjectDetailMobile_RightContent_FileMedia = (FileMedia_FileMedia);

;// CONCATENATED MODULE: ./src/modules/Mobile/ProjectDetailMobile/ProjectMobileTab.tsx












let TABS = [
    {
        key: "review",
        label: "Review",
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetail_ListReview["default"], {
            reviewFilter: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetailMobile_ReviewFilter, {})
        })
    },
    {
        key: "vote",
        label: "Ti\xeau ch\xed đ\xe1nh gi\xe1",
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContent_Evaluation, {})
    },
    {
        key: "file",
        label: "File",
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetailMobile_RightContent_FileMedia, {})
    },
    {
        key: "Th\xf4ng tin",
        label: "Th\xf4ng tin",
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContent_AboutProject, {})
    }
];
const ProjectMobileTab = ()=>{
    var _tabMobile_find;
    const [activeTab, setActiveTab] = (0,react.useState)("review");
    const { projectListFile , setProjectListFile , setSelectedViewFiles , project  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const scrollTab = (0,react.useRef)(null);
    const tabMobile = (0,react.useMemo)(()=>{
        var _project_votes;
        const isHasScore = project === null || project === void 0 ? void 0 : (_project_votes = project.votes) === null || _project_votes === void 0 ? void 0 : _project_votes.find((vote)=>vote.score > 0);
        if (!isHasScore) {
            return TABS.filter((item)=>{
                return item.key !== "vote";
            });
        } else return TABS;
    }, [
        project === null || project === void 0 ? void 0 : project.votes
    ]);
    const handleChangeTabFile = async ()=>{
        const res = await (0,get_list_file_review_project/* getListFileReviewProject */.c)(project === null || project === void 0 ? void 0 : project._id, {
            type: "".concat(media/* MediaTypeEnum.IMAGE */.L.IMAGE, ",").concat(media/* MediaTypeEnum.VIDEO */.L.VIDEO, ",").concat(media/* MediaTypeEnum.FILE */.L.FILE),
            page: 1,
            limit: number/* PAGE_SIZE_FILE */.Ew
        });
        if (res) {
            setProjectListFile({
                ...res,
                results: [
                    ...res.results
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white flex-[1_1_auto] w-full ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overflow-auto flex w-full flex-nowrap no-scrollbar",
                ref: scrollTab,
                children: tabMobile.map((tab)=>{
                    const isActive = tab.key === activeTab;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: (e)=>{
                            scrollTab.current.scrollTo({
                                left: e.target.offsetLeft,
                                behavior: "smooth"
                            });
                            if (activeTab === "file") {
                                handleChangeTabFile();
                            }
                            setActiveTab(tab.key);
                            if (tab.key === "file") {
                                setSelectedViewFiles({
                                    currentFile: null,
                                    files: projectListFile === null || projectListFile === void 0 ? void 0 : projectListFile.results
                                });
                            }
                        },
                        className: (0,clsx_m/* default */.Z)("cursor-pointer border-b border-grey-200 hover:border-b-blue-500 hover:text-blue-500  px-6 py-3 whitespace-nowrap text-grey-500 flex-1 text-center", isActive ? "!text-blue-500 border-b-blue-500" : ""),
                        children: tab.label
                    }, tab.key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tab-content h-full",
                children: (_tabMobile_find = tabMobile.find((item)=>item.key === activeTab)) === null || _tabMobile_find === void 0 ? void 0 : _tabMobile_find.component
            }, activeTab)
        ]
    });
};
/* harmony default export */ var ProjectDetailMobile_ProjectMobileTab = (ProjectMobileTab);

// EXTERNAL MODULE: ./src/modules/Mobile/ProjectDetailMobile/RightContent/ModalViewDetailFile.tsx
var RightContent_ModalViewDetailFile = __webpack_require__(19826);
;// CONCATENATED MODULE: ./src/modules/Mobile/ProjectDetailMobile/index.tsx









const ProjectDetailMobile = ()=>{
    const { project , checkFollowProject: dataFollowProject , setCheckFollowProject , selectedViewFiles  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const { token  } = (0,useAuth/* useAuth */.a)();
    const handleCheckFollowProject = (0,react.useCallback)(async ()=>{
        const res = await checkFollowProject({
            project: project === null || project === void 0 ? void 0 : project._id
        }, token);
        if (res === null || res === void 0 ? void 0 : res.results) {
            setCheckFollowProject(true);
        } else {
            setCheckFollowProject(false);
        }
    }, [
        project === null || project === void 0 ? void 0 : project._id,
        setCheckFollowProject,
        token
    ]);
    (0,react.useEffect)(()=>{
        if (token) {
            handleCheckFollowProject();
        }
    }, [
        handleCheckFollowProject,
        token
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "wrap-home bg-grey-50 min-h-screen flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetailMobile_HeaderDetail/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetailMobile_HeaderProjectInfo, {
                project: project,
                isFollowProject: dataFollowProject
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetailMobile_ProjectMobileTab, {}),
            (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContent_ModalViewDetailFile/* default */.Z, {}) : null
        ]
    });
};
/* harmony default export */ var Mobile_ProjectDetailMobile = (ProjectDetailMobile);

// EXTERNAL MODULE: ./src/components/Seo/Meta.tsx
var Meta = __webpack_require__(48831);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
;// CONCATENATED MODULE: ./src/pages/project/[id].tsx





//import Home from '@/modules/Desktop/Home'
//import HomeMobile from '@/modules/Mobile/Home'












var __N_SSP = true;
function PageSlug(props) {
    var _props_project, _props_project_logo, _props_project_logo1, _props_project_logo2;
    (0,react.useEffect)(()=>{
        window.history.scrollRestoration = "manual";
    }, []);
    const { isMobile  } = (0,react.useContext)(device_context/* DeviceContext */.T);
    const router = (0,next_router.useRouter)();
    const { userDataHeader  } = (0,useAuth/* useAuth */.a)();
    const handleTracking = (0,react.useCallback)(async ()=>{
        if (userDataHeader) try {
            var _props_project, _props_project1;
            await trackingProject((_props_project = props.project) === null || _props_project === void 0 ? void 0 : _props_project._id);
            await axios/* default.request */.Z.request({
                method: "post",
                headers: userDataHeader,
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "v1/interact/createview/" + ((_props_project1 = props.project) === null || _props_project1 === void 0 ? void 0 : _props_project1._id)
            });
        } catch (error) {}
    }, [
        (_props_project = props.project) === null || _props_project === void 0 ? void 0 : _props_project._id,
        userDataHeader
    ]);
    (0,react.useEffect)(()=>{
        handleTracking();
    }, [
        handleTracking
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.project ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* Meta */.h, {
                    title: props.project.title,
                    description: props.project.description,
                    ogImage: {
                        width: 600,
                        height: 315,
                        url: ((_props_project_logo = props.project.logo) === null || _props_project_logo === void 0 ? void 0 : _props_project_logo.uri) ? (0,utils/* resizeOnFlyUrl */.Li)({
                            resizingType: "fill",
                            gravity: "ce",
                            width: 600,
                            height: 315,
                            uri: props.project.logo.uri
                        }) : ((_props_project_logo1 = props.project.logo) === null || _props_project_logo1 === void 0 ? void 0 : _props_project_logo1.url) ? (_props_project_logo2 = props.project.logo) === null || _props_project_logo2 === void 0 ? void 0 : _props_project_logo2.url : environment/* STATIC_DOMAIN */.xm + "/" + project_constant/* DEFAULT_LOGO_PROJECT */.J3,
                        alt: props.project.title
                    },
                    canonical: (0,route/* getCanonicalUrl */.Z2)(router)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(project_context/* ProjectContextProvider */.M, {
                    project: props.project,
                    projectListVote: props.projectListVote,
                    projectListFile: props.projectListFile,
                    checkFollowProject: props.checkIsFollowProject,
                    projectVideos: props.projectVideos,
                    numberNewReview: props.numberNewReview,
                    children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_ProjectDetailMobile, {
                        ...props
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_ProjectDetail, {
                        ...props
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-screen h-[100vh] gap-8 flex items-center justify-center flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: "Kh\xf4ng t\xecm thấy dự \xe1n"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        btnType: "filled",
                        children: "Về trang chủ"
                    })
                })
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2544,4824,314,9510,5620,1590,1696,4749,5051,7043,5214,5315,8703,6289,5646,8343,8758,1800,7436,9774,2888,179], function() { return __webpack_exec__(81244); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);